const ArabicTokens = {
    "name": "arabic",
    "selectors": [":lang(ar)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', 'Geeza Pro', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'AvenirNext', 'Geeza Pro', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": ".75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-1": "33px",
        "font-size-line-height-heading-text-2": "30px",
        "font-size-line-height-heading-text-3": "27px",
        "font-size-line-height-heading-text-4": "24px",
        "font-size-line-height-heading-text-5": "21px",
        "font-size-line-height-heading-text-6": "18px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.5rem 0.75rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const ArabicPseudoTokens = {
    "name": "arabicPseudo",
    "selectors": [":lang(ar-xx)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', 'PseudoArabic', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'AvenirNext', 'PseudoArabic', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": ".75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-1": "33px",
        "font-size-line-height-heading-text-2": "30px",
        "font-size-line-height-heading-text-3": "27px",
        "font-size-line-height-heading-text-4": "24px",
        "font-size-line-height-heading-text-5": "21px",
        "font-size-line-height-heading-text-6": "18px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.5rem 0.75rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const ChineseChinaTokens = {
    "name": "chineseChina",
    "selectors": [":lang(zh)", ":lang(zh-cn)", ":lang(zh-sg)", ":lang(zh-hans)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', '微软雅黑体', 'Microsoft YaHei New', '微软雅黑', 'Microsoft Yahei', '宋体', 'SimSun', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'AvenirNext', '微软雅黑体', 'Microsoft YaHei New', '微软雅黑', 'Microsoft Yahei', '宋体', 'SimSun', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-1": "1.625rem",
        "font-size-heading-text-2": "1.4375rem",
        "font-size-heading-text-3": "1.25rem",
        "font-size-heading-text-4": "1.125rem",
        "font-size-heading-text-5": "1rem",
        "font-size-heading-text-6": ".875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "27px",
        "font-size-line-height-body-text-m": "24px",
        "font-size-line-height-body-text-s": "21px",
        "font-size-line-height-body-text-xl": "30px",
        "font-size-line-height-body-text-xs": "19.5px",
        "font-size-line-height-body-text-xxl": "34.5px",
        "font-size-line-height-body-text-xxs": "16.5px",
        "font-size-line-height-body-text-xxxl": "39px",
        "font-size-line-height-body-text-xxxs": "15px",
        "font-size-line-height-body-text-xxxxl": "48px",
        "font-size-line-height-display-text-1": "124.5px",
        "font-size-line-height-display-text-2": "99px",
        "font-size-line-height-display-text-3": "69px",
        "font-size-line-height-heading-text-1": "34.5px",
        "font-size-line-height-heading-text-2": "30px",
        "font-size-line-height-heading-text-3": "34.5px",
        "font-size-line-height-heading-text-4": "30px",
        "font-size-line-height-heading-text-5": "24px",
        "font-size-line-height-heading-text-6": "21px",
        "font-size-line-height-heading-text-l": "27px",
        "font-size-line-height-heading-text-m": "24px",
        "font-size-line-height-heading-text-s": "21px",
        "font-size-line-height-heading-text-xl": "30px",
        "font-size-line-height-heading-text-xxl": "34.5px",
        "font-size-line-height-heading-text-xxxl": "39px",
        "font-size-line-height-heading-text-xxxxl": "48px",
        "font-size-line-height-heading-text-xxxxxl": "99px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-text-transform-uppercase": "initial",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1.125rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem",
        "space-block-l": "1.625rem",
        "space-block-m": "0.875rem",
        "space-block-s": "0.5625rem",
        "space-block-xl": "2.25rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.875remm",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "3.25rem",
        "space-block-xxxxl": "4.125rem",
        "space-block-xxxxxl": "4.625rem",
        "space-inline-l": "1.625rem",
        "space-inline-m": "1.25rem",
        "space-inline-s": "0.5625rem",
        "space-inline-xl": "2.25rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.875rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3.25rem",
        "space-inline-xxxxl": "4.125rem",
        "space-inline-xxxxxl": "4.625rem",
        "space-squish-l": "0.875rem 1.625rem",
        "space-squish-m": "0.5625rem 1.125rem",
        "space-squish-s": "0.25rem 0.5625rem",
        "space-squish-xl": "1.125rem 2.25rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.4375rem 2.875rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.625rem 0.875rem",
        "space-stretch-m": "1.125rem 0.5625rem",
        "space-stretch-s": "0.5625rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const ChineseHongKongTokens = {
    "name": "chineseHongKong",
    "selectors": [":lang(zh-hk)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', '微軟正黑體', 'Microsoft JhengHei', '黑體-繁', 'Heiti TC', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'AvenirNext', '微軟正黑體', 'Microsoft JhengHei', '黑體-繁', 'Heiti TC', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": ".75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-1": "33px",
        "font-size-line-height-heading-text-2": "30px",
        "font-size-line-height-heading-text-3": "27px",
        "font-size-line-height-heading-text-4": "24px",
        "font-size-line-height-heading-text-5": "21px",
        "font-size-line-height-heading-text-6": "18px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-text-transform-uppercase": "initial",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.5rem 0.75rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const ChinesePseudoTokens = {
    "name": "chinesePseudo",
    "selectors": [":lang(zh-cn-pseudo)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', '微软雅黑体', 'Microsoft YaHei New', '微软雅黑', 'Microsoft Yahei', '宋体', 'SimSun', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'AvenirNext', '微软雅黑体', 'Microsoft YaHei New', '微软雅黑', 'Microsoft Yahei', '宋体', 'SimSun', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-1": "1.625rem",
        "font-size-heading-text-2": "1.4375rem",
        "font-size-heading-text-3": "1.25rem",
        "font-size-heading-text-4": "1.125rem",
        "font-size-heading-text-5": "1rem",
        "font-size-heading-text-6": ".875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "27px",
        "font-size-line-height-body-text-m": "24px",
        "font-size-line-height-body-text-s": "21px",
        "font-size-line-height-body-text-xl": "30px",
        "font-size-line-height-body-text-xs": "19.5px",
        "font-size-line-height-body-text-xxl": "34.5px",
        "font-size-line-height-body-text-xxs": "16.5px",
        "font-size-line-height-body-text-xxxl": "39px",
        "font-size-line-height-body-text-xxxs": "15px",
        "font-size-line-height-body-text-xxxxl": "48px",
        "font-size-line-height-display-text-1": "124.5px",
        "font-size-line-height-display-text-2": "99px",
        "font-size-line-height-display-text-3": "69px",
        "font-size-line-height-heading-text-1": "34.5px",
        "font-size-line-height-heading-text-2": "30px",
        "font-size-line-height-heading-text-3": "34.5px",
        "font-size-line-height-heading-text-4": "30px",
        "font-size-line-height-heading-text-5": "24px",
        "font-size-line-height-heading-text-6": "21px",
        "font-size-line-height-heading-text-l": "27px",
        "font-size-line-height-heading-text-m": "24px",
        "font-size-line-height-heading-text-s": "21px",
        "font-size-line-height-heading-text-xl": "30px",
        "font-size-line-height-heading-text-xxl": "34.5px",
        "font-size-line-height-heading-text-xxxl": "39px",
        "font-size-line-height-heading-text-xxxxl": "48px",
        "font-size-line-height-heading-text-xxxxxl": "99px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-text-transform-uppercase": "initial",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1.125rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem",
        "space-block-l": "1.625rem",
        "space-block-m": "0.875rem",
        "space-block-s": "0.5625rem",
        "space-block-xl": "2.25rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.875remm",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "3.25rem",
        "space-block-xxxxl": "4.125rem",
        "space-block-xxxxxl": "4.625rem",
        "space-inline-l": "1.625rem",
        "space-inline-m": "1.25rem",
        "space-inline-s": "0.5625rem",
        "space-inline-xl": "2.25rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.875rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3.25rem",
        "space-inline-xxxxl": "4.125rem",
        "space-inline-xxxxxl": "4.625rem",
        "space-squish-l": "0.875rem 1.625rem",
        "space-squish-m": "0.5625rem 1.125rem",
        "space-squish-s": "0.25rem 0.5625rem",
        "space-squish-xl": "1.125rem 2.25rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.4375rem 2.875rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.625rem 0.875rem",
        "space-stretch-m": "1.125rem 0.5625rem",
        "space-stretch-s": "0.5625rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const DarkTokens = {
    "name": "dark",
    "selectors": ["[data-sas-theme='dark']"],
    "tokens": {
        "color-action-background-control-alert": "hsl(205, 90%, 8%)",
        "color-action-background-control-disabled": "hsl(205, 90%, 8%)",
        "color-action-background-control-hover": "hsl(205, 90%, 8%)",
        "color-action-background-control-non-editable": "hsla(205, 25%, 70%, 0.16)",
        "color-action-background-control-normal": "hsl(205, 90%, 8%)",
        "color-action-background-control-placeholder": "hsl(205, 90%, 8%)",
        "color-action-background-control-primary": "hsl(205, 97%, 63%)",
        "color-action-background-control-read-only": "hsla(0, 100%, 100%, 0)",
        "color-action-background-control-selected": "hsl(205, 90%, 8%)",
        "color-action-background-control-warning": "hsl(205, 90%, 8%)",
        "color-action-background-emphasis-active": "hsla(205, 97%, 63%, 0.24)",
        "color-action-background-emphasis-disabled": "hsla(205, 97%, 63%, 0.08)",
        "color-action-background-emphasis-hover": "hsla(205, 97%, 63%, 0.16)",
        "color-action-background-emphasis-normal": "hsla(205, 97%, 63%, 0.08)",
        "color-action-background-emphasis-selected": "hsla(205, 97%, 63%, 0.24)",
        "color-action-background-emphasis-visited": "hsla(205, 97%, 63%, 0.08)",
        "color-action-background-focus": "hsl(205, 97%, 63%)",
        "color-action-background-focus-inverse": "hsl(0, 0%, 0%)",
        "color-action-background-on-off-disabled": "hsl(205, 90%, 8%)",
        "color-action-background-on-off-hover": "hsl(205, 90%, 8%)",
        "color-action-background-on-off-normal": "hsl(205, 90%, 8%)",
        "color-action-background-on-off-read-only": "hsla(205, 25%, 70%, 0.08)",
        "color-action-background-on-off-selected": "hsl(329, 75%, 43%)",
        "color-action-background-on-off-selected-disabled": "hsla(329, 75%, 43%, 0.24)",
        "color-action-background-secondary-disabled": "hsla(205, 25%, 70%, 0.08)",
        "color-action-background-secondary-normal": "hsla(205, 90%, 8%, 0.08)",
        "color-action-background-secondary-selected": "hsla(329, 75%, 43%, 0.24)",
        "color-action-background-secondary-selected-disabled": "hsla(329, 75%, 43%, 0.16)",
        "color-action-background-standard-active": "hsla(205, 97%, 63%, 0.48)",
        "color-action-background-standard-disabled": "hsla(205, 25%, 70%, 0.08)",
        "color-action-background-standard-hover": "hsla(205, 25%, 70%, 0.16)",
        "color-action-background-standard-normal": "hsla(205, 25%, 70%, 0.08)",
        "color-action-background-standard-selected": "hsla(205, 97%, 63%, 0.48)",
        "color-action-background-standard-selected-inactive": "hsla(205, 25%, 70%, 0.16)",
        "color-action-background-standard-visited": "hsla(205, 25%, 70%, 0.08)",
        "color-action-background-subtle-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-background-subtle-hover": "hsla(205, 25%, 70%, 0.16)",
        "color-action-background-subtle-normal": "hsla(0, 100%, 100%, 0)",
        "color-action-background-subtle-selected": "hsla(205, 25%, 70%, 0.24)",
        "color-action-background-subtle-selected-inactive": "hsla(205, 25%, 70%, 0.16)",
        "color-action-border-bottom-control-alert": "hsl(360, 100%, 65%)",
        "color-action-border-bottom-control-hover": "hsl(205, 25%, 70%)",
        "color-action-border-bottom-control-normal": "hsl(205, 25%, 70%)",
        "color-action-border-bottom-control-selected": "hsl(205, 97%, 63%)",
        "color-action-border-bottom-control-warning": "hsl(40, 100%, 58%)",
        "color-action-border-control-alert": "hsl(360, 100%, 65%)",
        "color-action-border-control-disabled": "hsla(205, 25%, 70%, 0.32)",
        "color-action-border-control-hover": "hsl(205, 25%, 70%)",
        "color-action-border-control-normal": "hsl(205, 25%, 70%)",
        "color-action-border-control-placeholder": "hsl(205, 25%, 70%)",
        "color-action-border-control-read-only": "hsla(0, 100%, 100%, 0)",
        "color-action-border-control-selected": "hsl(205, 97%, 63%)",
        "color-action-border-control-warning": "hsl(40, 100%, 58%)",
        "color-action-border-emphasis-active": "hsl(205, 97%, 63%)",
        "color-action-border-emphasis-disabled": "hsla(0, 0%, 0%, 0)",
        "color-action-border-emphasis-hover": "hsl(205, 97%, 63%)",
        "color-action-border-emphasis-normal": "hsl(205, 97%, 63%)",
        "color-action-border-emphasis-selected": "hsl(205, 97%, 63%)",
        "color-action-border-emphasis-visited": "hsl(205, 97%, 63%)",
        "color-action-border-focus": "hsl(205, 97%, 63%)",
        "color-action-border-focus-inverse": "hsl(0, 100%, 100%)",
        "color-action-border-on-off-disabled": "hsla(205, 25%, 70%, 0.32)",
        "color-action-border-on-off-hover": "hsl(205, 25%, 70%)",
        "color-action-border-on-off-normal": "hsl(205, 25%, 70%)",
        "color-action-border-on-off-read-only": "hsl(205, 25%, 70%)",
        "color-action-border-on-off-selected": "hsl(329, 75%, 43%)",
        "color-action-border-on-off-selected-disabled": "hsla(0, 0%, 0%, 0)",
        "color-action-border-secondary-disabled": "hsla(0, 0%, 0%, 0)",
        "color-action-border-secondary-normal": "hsl(205, 25%, 70%)",
        "color-action-border-secondary-selected": "hsl(329, 75%, 43%)",
        "color-action-border-secondary-selected-disabled": "hsla(0, 0%, 0%, 0)",
        "color-action-border-standard-active": "hsl(205, 97%, 63%)",
        "color-action-border-standard-disabled": "hsla(0, 0%, 0%, 0)",
        "color-action-border-standard-hover": "hsl(205, 25%, 70%)",
        "color-action-border-standard-normal": "hsla(205, 25%, 70%, 0.24)",
        "color-action-border-standard-selected": "hsl(205, 97%, 63%)",
        "color-action-border-standard-selected-inactive": "hsla(0, 0%, 0%, 0)",
        "color-action-border-standard-visited": "hsl(205, 25%, 70%)",
        "color-action-border-subtle-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-border-subtle-hover": "hsla(0, 100%, 100%, 0)",
        "color-action-border-subtle-normal": "hsla(0, 100%, 100%, 0)",
        "color-action-border-subtle-selected": "hsla(0, 100%, 100%, 0)",
        "color-action-border-subtle-selected-inactive": "hsla(0, 100%, 100%, 0)",
        "color-action-focus": "hsl(205, 97%, 63%)",
        "color-action-icon-control-alert": "hsl(360, 100%, 65%)",
        "color-action-icon-control-disabled": "hsla(0, 100%, 100%, 0.32)",
        "color-action-icon-control-hover": "hsl(0, 100%, 100%)",
        "color-action-icon-control-normal": "hsl(0, 100%, 100%)",
        "color-action-icon-control-read-only": "hsl(0, 100%, 100%)",
        "color-action-icon-control-selected": "hsl(0, 100%, 100%)",
        "color-action-icon-control-warning": "hsl(40, 100%, 58%)",
        "color-action-icon-emphasis-active": "hsl(205, 97%, 63%)",
        "color-action-icon-emphasis-disabled": "hsla(205, 97%, 63%, 0.32)",
        "color-action-icon-emphasis-hover": "hsl(205, 97%, 63%)",
        "color-action-icon-emphasis-normal": "hsl(205, 97%, 63%)",
        "color-action-icon-emphasis-selected": "hsl(205, 97%, 63%)",
        "color-action-icon-emphasis-visited": "hsl(205, 97%, 63%)",
        "color-action-icon-on-off-disabled": "hsla(0, 100%, 100%, 0.32)",
        "color-action-icon-on-off-hover": "hsl(0, 100%, 100%)",
        "color-action-icon-on-off-normal": "hsl(0, 100%, 100%)",
        "color-action-icon-on-off-read-only": "hsl(0, 100%, 100%)",
        "color-action-icon-on-off-selected": "hsl(0, 100%, 100%)",
        "color-action-icon-on-off-selected-disabled": "hsla(0, 100%, 100%, 0.32)",
        "color-action-icon-standard-active": "hsl(0, 0%, 100%)",
        "color-action-icon-standard-disabled": "hsla(0, 100%, 100%, 0.32)",
        "color-action-icon-standard-hover": "hsl(0, 100%, 100%)",
        "color-action-icon-standard-normal": "hsl(0, 100%, 100%)",
        "color-action-icon-standard-selected": "hsl(0, 100%, 100%)",
        "color-action-icon-standard-selected-inactive": "hsl(0, 0%, 100%)",
        "color-action-icon-standard-visited": "hsl(0, 0%, 100%)",
        "color-action-icon-subtle-disabled": "hsla(0, 100%, 100%, 0.32)",
        "color-action-icon-subtle-hover": "hsl(0, 100%, 100%)",
        "color-action-icon-subtle-normal": "hsl(0, 100%, 100%)",
        "color-action-icon-subtle-selected": "hsl(0, 100%, 100%)",
        "color-action-icon-subtle-selected-inactive": "hsl(0, 0%, 100%)",
        "color-action-link-active": "hsl(0, 100%, 100%)",
        "color-action-link-hover": "hsl(0, 100%, 100%)",
        "color-action-link-normal": "hsl(0, 100%, 100%)",
        "color-action-link-visited": "hsl(0, 100%, 100%)",
        "color-action-text-control-alert": "hsl(0, 100%, 100%)",
        "color-action-text-control-disabled": "hsla(0, 100%, 100%, 0.32)",
        "color-action-text-control-hover": "hsl(0, 100%, 100%)",
        "color-action-text-control-normal": "hsl(0, 100%, 100%)",
        "color-action-text-control-placeholder": "hsl(223, 10%, 64%)",
        "color-action-text-control-read-only": "hsl(0, 100%, 100%)",
        "color-action-text-control-selected": "hsl(0, 100%, 100%)",
        "color-action-text-control-visited": "hsl(0, 100%, 100%)",
        "color-action-text-control-warning": "hsl(0, 100%, 100%)",
        "color-action-text-emphasis-active": "hsl(205, 97%, 63%)",
        "color-action-text-emphasis-disabled": "hsla(205, 97%, 63%, 0.32)",
        "color-action-text-emphasis-hover": "hsl(205, 97%, 63%)",
        "color-action-text-emphasis-normal": "hsl(205, 97%, 63%)",
        "color-action-text-emphasis-selected": "hsl(205, 97%, 63%)",
        "color-action-text-emphasis-visited": "hsl(205, 97%, 63%)",
        "color-action-text-on-off-disabled": "hsla(0, 100%, 100%, 0.32)",
        "color-action-text-on-off-hover": "hsl(0, 100%, 100%)",
        "color-action-text-on-off-normal": "hsl(0, 100%, 100%)",
        "color-action-text-on-off-read-only": "hsl(0, 100%, 100%)",
        "color-action-text-on-off-selected": "hsl(0, 100%, 100%)",
        "color-action-text-on-off-selected-disabled": "hsla(0, 100%, 100%, 0.32)",
        "color-action-text-secondary-disabled": "hsla(0, 100%, 100%, 0.32)",
        "color-action-text-secondary-normal": "hsl(0, 100%, 100%)",
        "color-action-text-secondary-selected": "hsl(0, 100%, 100%)",
        "color-action-text-secondary-selected-disabled": "hsla(0, 100%, 100%, 0.32)",
        "color-action-text-standard-active": "hsl(0, 0%, 100%)",
        "color-action-text-standard-disabled": "hsla(0, 100%, 100%, 0.32)",
        "color-action-text-standard-hover": "hsl(0, 100%, 100%)",
        "color-action-text-standard-normal": "hsl(0, 100%, 100%)",
        "color-action-text-standard-selected": "hsl(0, 100%, 100%)",
        "color-action-text-standard-selected-inactive": "hsl(0, 0%, 100%)",
        "color-action-text-standard-visited": "hsl(0, 0%, 100%)",
        "color-action-text-subtle-disabled": "hsla(0, 100%, 100%, 0.32)",
        "color-action-text-subtle-hover": "hsl(0, 100%, 100%)",
        "color-action-text-subtle-normal": "hsl(0, 100%, 100%)",
        "color-action-text-subtle-selected": "hsl(0, 100%, 100%)",
        "color-action-text-subtle-selected-inactive": "hsl(0, 100%, 100%)",
        "color-body-icon": "hsl(0, 100%, 100%)",
        "color-body-text": "hsl(0, 100%, 100%)",
        "color-container-background-0": "hsl(205, 90%, 8%)",
        "color-container-background-1": "hsl(205, 90%, 15%)",
        "color-container-background-2": "hsl(205, 90%, 12%)",
        "color-container-background-3": "hsl(205, 90%, 15%)",
        "color-container-background-4": "hsl(205, 22%, 26%)",
        "color-container-border-4": "hsl(205, 22%, 26%)",
        "color-dataviz-graph-alt1": "#35A5FF",
        "color-dataviz-graph-alt2": "#EBCF5D",
        "color-dataviz-graph-alt3": "#837CFF",
        "color-dataviz-graph-alt4": "#EB8C4A",
        "color-dataviz-graph-alt5": "#36D7E3",
        "color-dataviz-graph-alt6": "#D6697A",
        "color-dataviz-graph-alt7": "#27C99F",
        "color-dataviz-graph-alt8": "#EB7DCF",
        "color-dataviz-graph1": "#2470ad",
        "color-dataviz-graph2": "#98863c",
        "color-dataviz-graph3": "#5954ad",
        "color-dataviz-graph4": "#985b30",
        "color-dataviz-graph5": "#238a92",
        "color-dataviz-graph6": "#84414b",
        "color-dataviz-graph7": "#17785f",
        "color-dataviz-graph8": "#985186",
        "color-dataviz-kpi-alt1": "#A64141",
        "color-dataviz-kpi-alt3": "#C79F27",
        "color-dataviz-kpi-alt5": "#0E7D55",
        "color-dataviz-kpi1": "#84414b",
        "color-dataviz-kpi3": "#98863c",
        "color-dataviz-kpi5": "#17785f",
        "color-display-icon": "hsl(0, 100%, 100%)",
        "color-display-text": "hsl(0, 100%, 100%)",
        "color-heading-icon": "hsl(0, 100%, 100%)",
        "color-heading-text": "hsl(0, 100%, 100%)",
        "color-highlight-text": "hsl(205, 97%, 63%)",
        "color-highlight-text-inverse": "hsl(0, 0%, 0%)",
        "color-icon-neutral": "hsl(0, 100%, 100%)",
        "color-icon-primary": "hsl(205, 97%, 63%)",
        "color-icon-secondary": "hsl(329, 75%, 43%)",
        "color-label-text": "hsl(223, 10%, 64%)",
        "color-neutral": "hsl(205, 25%, 70%)",
        "color-primary": "hsl(205, 97%, 63%)",
        "color-secondary": "hsl(329, 75%, 43%)",
        "color-status-alert": "hsl(360, 100%, 65%)",
        "color-status-background-alert": "hsl(205, 90%, 8%)",
        "color-status-background-info": "hsl(205, 90%, 8%)",
        "color-status-background-neutral": "hsl(219, 12%, 64%)",
        "color-status-background-success": "hsl(205, 90%, 8%)",
        "color-status-background-warning": "hsl(205, 90%, 8%)",
        "color-status-border-alert": "hsl(360, 100%, 65%)",
        "color-status-border-info": "hsl(205, 99%, 59%)",
        "color-status-border-neutral": "hsl(219, 12%, 64%)",
        "color-status-border-success": "hsl(124, 85%, 36%)",
        "color-status-border-warning": "hsl(40, 100%, 58%)",
        "color-status-icon-alert": "hsl(0, 100%, 64%)",
        "color-status-icon-info": "hsl(205, 99%, 59%)",
        "color-status-icon-neutral": "hsl(219, 12%, 64%)",
        "color-status-icon-success": "hsl(124, 85%, 36%)",
        "color-status-icon-warning": "hsl(40, 100%, 58%)",
        "color-status-info": "hsl(205, 99%, 59%)",
        "color-status-neutral": "hsl(205, 25%, 70%)",
        "color-status-success": "hsl(124, 85%, 36%)",
        "color-status-text-alert": "hsl(360, 100%, 65%)",
        "color-status-text-info": "hsl(205, 99%, 59%)",
        "color-status-text-neutral": "hsl(219, 0%, 100%)",
        "color-status-text-success": "hsl(124, 85%, 36%)",
        "color-status-text-warning": "hsl(40, 100%, 58%)",
        "color-status-warning": "hsl(40, 100%, 58%)",
        "color-syntax-text-01": "hsl(223, 11%, 88%)",
        "color-syntax-text-02": "hsl(218, 12%, 64%)",
        "color-syntax-text-03": "hsl(26, 93%, 70%)",
        "color-syntax-text-04": "hsl(7, 82%, 69%)",
        "color-syntax-text-05": "hsl(267, 72%, 67%)",
        "color-syntax-text-06": "hsl(212, 94%, 62%)",
        "color-syntax-text-07": "hsl(212, 95%, 78%)",
        "color-syntax-text-08": "hsl(169, 40%, 52%)",
        "color-syntax-text-09": "hsl(79, 51%, 50%)",
        "color-syntax-text-attribute-name": "hsl(212, 95%, 78%)",
        "color-syntax-text-attribute-value": "hsl(7, 82%, 69%)",
        "color-syntax-text-boolean": "hsl(267, 72%, 67%)",
        "color-syntax-text-character-constant": "hsl(169, 40%, 52%)",
        "color-syntax-text-class-name": "hsl(169, 40%, 52%)",
        "color-syntax-text-comment": "hsl(79, 51%, 50%)",
        "color-syntax-text-control": "hsl(267, 72%, 67%)",
        "color-syntax-text-data": "hsl(26, 93%, 70%)",
        "color-syntax-text-declaration": "hsl(212, 94%, 62%)",
        "color-syntax-text-default": "hsl(223, 11%, 88%)",
        "color-syntax-text-function": "hsl(267, 72%, 67%)",
        "color-syntax-text-identifier": "hsl(223, 11%, 88%)",
        "color-syntax-text-keyword": "hsl(212, 94%, 62%)",
        "color-syntax-text-namespace": "hsl(169, 40%, 52%)",
        "color-syntax-text-normal": "hsl(223, 11%, 88%)",
        "color-syntax-text-numeric-constant": "hsl(169, 40%, 52%)",
        "color-syntax-text-operator": "hsl(212, 95%, 78%)",
        "color-syntax-text-proc-name": "hsl(212, 95%, 78%)",
        "color-syntax-text-property": "hsl(212, 94%, 62%)",
        "color-syntax-text-punctuation": "hsl(218, 12%, 64%)",
        "color-syntax-text-punctuation-brackets": "hsl(218, 12%, 64%)",
        "color-syntax-text-section": "hsl(212, 95%, 78%)",
        "color-syntax-text-separator": "hsl(223, 11%, 88%)",
        "color-syntax-text-source": "hsl(212, 94%, 62%)",
        "color-syntax-text-storage-type": "hsl(212, 94%, 62%)",
        "color-syntax-text-string": "hsl(7, 82%, 69%)",
        "color-syntax-text-tag": "hsl(212, 94%, 62%)",
        "color-syntax-text-variable": "hsl(212, 95%, 78%)",
        "color-tag-background-1": "hsla(205, 97%, 63%, 0.16)",
        "color-tag-background-2": "hsla(329, 75%, 43%, 0.16)",
        "color-tag-background-3": "hsla(205, 25%, 70%, 0.16)",
        "color-tag-border-1": "hsl(205, 97%, 63%)",
        "color-tag-border-2": "hsl(329, 75%, 43%)",
        "color-tag-border-3": "hsl(205, 25%, 70%)",
        "color-text-neutral": "hsl(0, 100%, 100%)",
        "color-text-neutral-inverse": "hsl(0, 0%, 0%)",
        "color-text-primary": "hsl(205, 97%, 63%)",
        "color-text-primary-inverse": "hsl(0, 0%, 0%)",
        "color-text-secondary": "hsl(329, 75%, 43%)",
        "color-thumbnail-fill-1": "hsl(205, 97%, 90%)",
        "color-thumbnail-fill-2": "hsl(205, 97%, 80%)",
        "color-thumbnail-fill-3": "hsl(205, 97%, 70%)",
        "color-thumbnail-fill-4": "hsl(205, 97%, 63%)",
        "color-zero-state-base-fill-1": "hsl(205, 97%, 8%)",
        "color-zero-state-base-fill-2": "hsl(205, 25%, 70%)",
        "color-zero-state-base-fill-3": "hsl(205, 25%, 46%)",
        "color-zero-state-modifier-fill-1": "hsl(205, 22%, 26%)",
        "color-zero-state-modifier-fill-2": "hsl(205, 97%, 63%)",
        "color-zero-state-modifier-fill-3": "hsl(205, 97%, 69%)",
        "color-zero-state-modifier-fill-4": "hsl(205, 25%, 30%)",
        "color-zero-state-modifier-fill-5": "hsl(205, 25%, 70%)",
        "duration-100": "100ms",
        "duration-1000": "1s",
        "duration-200": "200ms",
        "duration-250": "250ms",
        "duration-300": "300ms",
        "duration-400": "400ms",
        "duration-450": "450ms",
        "duration-500": "500ms",
        "duration-700": "700ms",
        "ease-in": "cubic-bezier(0, 0.5, 0.2, 1)",
        "ease-in-out": "cubic-bezier(0.5, 0, 0.2, 1)",
        "ease-out": "cubic-bezier(0.5, 0, 0.8, 1)",
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-family-secondary": "'AvenirNext', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-size-base-text": "16px",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": "0.75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-1": "30.8px",
        "font-size-line-height-heading-text-2": "28px",
        "font-size-line-height-heading-text-3": "25.2px",
        "font-size-line-height-heading-text-4": "22.4px",
        "font-size-line-height-heading-text-5": "19.6px",
        "font-size-line-height-heading-text-6": "16.8px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-size-ratio": "1.125",
        "font-size-ratio-major-second": "1.125",
        "font-size-ratio-major-third": "1.25",
        "font-size-ratio-minor-third": "1.2",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "2px",
        "font-space-letter-spacing-m": "1px",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "-1px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "font-space-word": "normal",
        "font-space-word-l": "2px",
        "font-space-word-m": "normal",
        "font-space-word-s": "1px",
        "font-style-expression": "normal",
        "font-style-expression-italic": "italic",
        "font-style-expression-normal": "normal",
        "font-style-expression-oblique": "oblique",
        "font-style-overflow-wrap": "anywhere",
        "font-style-overflow-wrap-anywhere": "anywhere",
        "font-style-overflow-wrap-break-word": "break-word",
        "font-style-overflow-wrap-normal": "normal",
        "font-style-text-transform": "none",
        "font-style-text-transform-capitalize": "capitalize",
        "font-style-text-transform-lowercase": "lowercase",
        "font-style-text-transform-none": "none",
        "font-style-text-transform-uppercase": "uppercase",
        "font-style-weight-300": "300",
        "font-style-weight-400": "400",
        "font-style-weight-500": "500",
        "font-style-weight-600": "600",
        "font-style-weight-700": "700",
        "font-style-word-break": "break-all",
        "font-style-word-break-break-all": "break-all",
        "font-style-word-break-break-word": "break-word",
        "font-style-word-break-keep-all": "keep-all",
        "font-style-word-break-normal": "normal",
        "shadow-depth-l": "0 8px 12px rgba(0, 0, 0, 0.04), 0 16px 24px rgba(0, 0, 0, 0.08)",
        "shadow-depth-m": "0 2px 4px rgba(0, 0, 0, 0.04), 0 8px 16px rgba(0, 0, 0, 0.08)",
        "shadow-depth-s": "0 2px 2px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xl": "0 16px 24px rgba(0, 0, 0, 0.04), 0 32px 48px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xs": "0 1px 2px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.08)",
        "size-action-border-width-focus": "1px",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-border-width-l": "3px",
        "size-border-width-m": "2px",
        "size-border-width-null": "0",
        "size-border-width-s": "1px",
        "size-container-l": "400px",
        "size-container-m": "320px",
        "size-container-null": "0",
        "size-container-s": "240px",
        "size-container-xl": "640px",
        "size-container-xs": "192px",
        "size-container-xxl": "960px",
        "size-container-xxs": "96px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "size-outline-width-l": "3px",
        "size-outline-width-m": "2px",
        "size-outline-width-s": "1px",
        "size-outline-width-xl": "4px",
        "size-zero-state-border-width": "0",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "2.875rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4.125rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.4375rem 0.8125rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem",
        "style-action-border-focus": "dotted"
    }
};

const EnglishTokens = {
    "name": "english",
    "selectors": [":lang(en)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-family-secondary": "'AvenirNext', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": "0.75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-1": "30.8px",
        "font-size-line-height-heading-text-2": "28px",
        "font-size-line-height-heading-text-3": "25.2px",
        "font-size-line-height-heading-text-4": "22.4px",
        "font-size-line-height-heading-text-5": "19.6px",
        "font-size-line-height-heading-text-6": "16.8px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "2.875rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4.125rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.4375rem 0.8125rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const HebrewTokens = {
    "name": "hebrew",
    "selectors": [":lang(he)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'AvenirNext', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": ".75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-1": "33px",
        "font-size-line-height-heading-text-2": "30px",
        "font-size-line-height-heading-text-3": "27px",
        "font-size-line-height-heading-text-4": "24px",
        "font-size-line-height-heading-text-5": "21px",
        "font-size-line-height-heading-text-6": "18px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.5rem 0.75rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const HighContrastTokens = {
    "name": "high-contrast",
    "selectors": ["[data-sas-theme='high-contrast']"],
    "tokens": {
        "color-action-background-control-alert": "hsl(0, 0%, 0%)",
        "color-action-background-control-disabled": "hsl(0, 0%, 0%)",
        "color-action-background-control-hover": "hsl(0, 0%, 0%)",
        "color-action-background-control-non-editable": "hsla(205, 30%, 90%, 0.16)",
        "color-action-background-control-normal": "hsl(0, 0%, 0%)",
        "color-action-background-control-placeholder": "hsl(0, 0%, 0%)",
        "color-action-background-control-primary": "hsl(205, 97%, 76%)",
        "color-action-background-control-read-only": "hsl(0, 0%, 0%)",
        "color-action-background-control-selected": "hsl(0, 0%, 0%)",
        "color-action-background-control-warning": "hsl(0, 0%, 0%)",
        "color-action-background-emphasis-active": "hsl(205, 97%, 76%)",
        "color-action-background-emphasis-disabled": "hsla(205, 97%, 76%, 0.16)",
        "color-action-background-emphasis-hover": "hsla(205, 97%, 76%, 0.16)",
        "color-action-background-emphasis-normal": "hsla(205, 97%, 76%, 0.08)",
        "color-action-background-emphasis-selected": "hsl(205, 97%, 76%)",
        "color-action-background-emphasis-visited": "hsla(205, 97%, 76%, 0.08)",
        "color-action-background-focus": "hsl(205, 97%, 76%)",
        "color-action-background-focus-inverse": "hsl(0, 0%, 0%)",
        "color-action-background-on-off-disabled": "hsl(0, 0%, 0%)",
        "color-action-background-on-off-hover": "hsl(0, 0%, 0%)",
        "color-action-background-on-off-normal": "hsl(0, 0%, 0%)",
        "color-action-background-on-off-read-only": "hsl(0, 0%, 0%)",
        "color-action-background-on-off-selected": "hsl(329, 75%, 90%)",
        "color-action-background-on-off-selected-disabled": "hsla(329, 75%, 90%, 0.24)",
        "color-action-background-secondary-disabled": "hsla(205, 30%, 90%, 0.16)",
        "color-action-background-secondary-normal": "hsl(0, 0%, 0%)",
        "color-action-background-secondary-selected": "hsl(329, 75%, 90%)",
        "color-action-background-secondary-selected-disabled": "hsla(329, 75%, 90%, 0.32)",
        "color-action-background-standard-active": "hsl(204, 29%, 90%)",
        "color-action-background-standard-disabled": "hsla(205, 30%, 90%, 0.16)",
        "color-action-background-standard-hover": "hsla(205, 30%, 90%, 0.16)",
        "color-action-background-standard-normal": "hsla(205, 30%, 90%, 0.08)",
        "color-action-background-standard-selected": "hsl(205, 30%, 90%)",
        "color-action-background-standard-selected-inactive": "hsla(205, 30%, 90%, 0.16)",
        "color-action-background-standard-visited": "hsla(204, 29%, 90%, 0.08)",
        "color-action-background-subtle-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-background-subtle-hover": "hsla(205, 30%, 90%, 0.16)",
        "color-action-background-subtle-normal": "hsla(0, 100%, 100%, 0)",
        "color-action-background-subtle-selected": "hsl(205, 30%, 90%)",
        "color-action-background-subtle-selected-inactive": "hsla(205, 30%, 90%, 0.16)",
        "color-action-border-bottom-control-alert": "hsl(360, 80%, 80%)",
        "color-action-border-bottom-control-hover": "hsl(205, 30%, 90%)",
        "color-action-border-bottom-control-normal": "hsl(205, 30%, 90%)",
        "color-action-border-bottom-control-selected": "hsl(205, 97%, 76%)",
        "color-action-border-bottom-control-warning": "hsl(40, 80%, 75%)",
        "color-action-border-control-alert": "hsl(360, 80%, 80%)",
        "color-action-border-control-disabled": "hsla(205, 30%, 90%, 0.32)",
        "color-action-border-control-hover": "hsl(205, 30%, 90%)",
        "color-action-border-control-normal": "hsl(205, 30%, 90%)",
        "color-action-border-control-placeholder": "hsl(205, 30%, 90%)",
        "color-action-border-control-read-only": "hsla(0, 100%, 100%, 0)",
        "color-action-border-control-selected": "hsl(205, 97%, 76%)",
        "color-action-border-control-warning": "hsl(40, 80%, 75%)",
        "color-action-border-emphasis-active": "hsl(205, 97%, 76%)",
        "color-action-border-emphasis-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-border-emphasis-hover": "hsl(205, 97%, 76%)",
        "color-action-border-emphasis-normal": "hsl(205, 97%, 76%)",
        "color-action-border-emphasis-selected": "hsl(205, 97%, 76%)",
        "color-action-border-emphasis-visited": "hsl(205, 97%, 76%)",
        "color-action-border-focus": "hsl(205, 97%, 76%)",
        "color-action-border-focus-inverse": "hsl(0, 0%, 0%)",
        "color-action-border-on-off-disabled": "hsla(205, 30%, 90%, 0.32)",
        "color-action-border-on-off-hover": "hsl(205, 30%, 90%)",
        "color-action-border-on-off-normal": "hsl(205, 30%, 90%)",
        "color-action-border-on-off-read-only": "hsl(0, 100%, 100%)",
        "color-action-border-on-off-selected": "hsl(329, 75%, 90%)",
        "color-action-border-on-off-selected-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-border-secondary-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-border-secondary-normal": "hsl(205, 30%, 90%)",
        "color-action-border-secondary-selected": "hsl(329, 75%, 90%)",
        "color-action-border-secondary-selected-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-border-standard-active": "hsl(204, 29%, 90%)",
        "color-action-border-standard-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-border-standard-hover": "hsl(205, 30%, 90%)",
        "color-action-border-standard-normal": "hsl(205, 30%, 90%)",
        "color-action-border-standard-selected": "hsl(205, 30%, 90%)",
        "color-action-border-standard-selected-inactive": "hsl(205, 30%, 90%)",
        "color-action-border-standard-visited": "hsl(204, 29%, 90%)",
        "color-action-border-subtle-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-border-subtle-hover": "hsla(0, 100%, 100%, 0)",
        "color-action-border-subtle-normal": "hsla(0, 100%, 100%, 0)",
        "color-action-border-subtle-selected": "hsl(205, 30%, 90%)",
        "color-action-border-subtle-selected-inactive": "hsl(205, 30%, 90%)",
        "color-action-focus": "hsl(205, 97%, 76%)",
        "color-action-icon-control-alert": "hsl(360, 80%, 80%)",
        "color-action-icon-control-disabled": "hsla(0, 0%, 100%, 0.32)",
        "color-action-icon-control-hover": "hsl(0, 0%, 100%)",
        "color-action-icon-control-normal": "hsl(0, 0%, 100%)",
        "color-action-icon-control-read-only": "hsl(0, 0%, 100%)",
        "color-action-icon-control-selected": "hsl(0, 0%, 0%)",
        "color-action-icon-control-warning": "hsl(40, 80%, 75%)",
        "color-action-icon-emphasis-active": "hsl(0, 0%, 0%)",
        "color-action-icon-emphasis-disabled": "hsla(205, 97%, 76%, 0.32)",
        "color-action-icon-emphasis-hover": "hsl(205, 97%, 76%)",
        "color-action-icon-emphasis-normal": "hsl(205, 97%, 76%)",
        "color-action-icon-emphasis-selected": "hsl(0, 0%, 0%)",
        "color-action-icon-emphasis-visited": "hsl(205, 97%, 76%)",
        "color-action-icon-on-off-disabled": "hsla(0, 0%, 100%, 0.32)",
        "color-action-icon-on-off-hover": "hsl(0, 0%, 100%)",
        "color-action-icon-on-off-normal": "hsl(0, 0%, 100%)",
        "color-action-icon-on-off-read-only": "hsl(0, 0%, 100%)",
        "color-action-icon-on-off-selected": "hsl(0, 0%, 0%)",
        "color-action-icon-on-off-selected-disabled": "hsla(0, 0%, 0%, 0.32)",
        "color-action-icon-standard-active": "hsl(0, 0%, 0%)",
        "color-action-icon-standard-disabled": "hsla(0, 0%, 100%, 0.48)",
        "color-action-icon-standard-hover": "hsl(0, 0%, 100%)",
        "color-action-icon-standard-normal": "hsl(0, 0%, 100%)",
        "color-action-icon-standard-selected": "hsl(0, 0%, 0%)",
        "color-action-icon-standard-selected-inactive": "hsl(0, 0%, 100%)",
        "color-action-icon-standard-visited": "hsl(0, 0%, 100%)",
        "color-action-icon-subtle-disabled": "hsla(0, 0%, 100%, 0.48)",
        "color-action-icon-subtle-hover": "hsl(0, 0%, 100%)",
        "color-action-icon-subtle-normal": "hsl(0, 0%, 100%)",
        "color-action-icon-subtle-selected": "hsl(0, 0%, 0%)",
        "color-action-icon-subtle-selected-inactive": "hsl(0, 0%, 100%)",
        "color-action-link-active": "hsl(0, 0%, 100%)",
        "color-action-link-hover": "hsl(0, 0%, 100%)",
        "color-action-link-normal": "hsl(0, 0%, 100%)",
        "color-action-link-visited": "hsl(0, 0%, 100%)",
        "color-action-text-control-alert": "hsl(0, 0%, 100%)",
        "color-action-text-control-disabled": "hsla(0, 0%, 100%, 0.32)",
        "color-action-text-control-hover": "hsl(0, 0%, 100%)",
        "color-action-text-control-normal": "hsl(0, 0%, 100%)",
        "color-action-text-control-placeholder": "hsl(0, 0%, 100%)",
        "color-action-text-control-read-only": "hsl(0, 0%, 100%)",
        "color-action-text-control-selected": "hsl(0, 0%, 100%)",
        "color-action-text-control-warning": "hsl(43, 0%, 100%)",
        "color-action-text-emphasis-active": "hsl(0, 0%, 0%)",
        "color-action-text-emphasis-disabled": "hsla(205, 97%, 76%, 0.32)",
        "color-action-text-emphasis-hover": "hsl(205, 97%, 76%)",
        "color-action-text-emphasis-normal": "hsl(205, 97%, 76%)",
        "color-action-text-emphasis-selected": "hsl(0, 0%, 0%)",
        "color-action-text-emphasis-visited": "hsl(205, 97%, 76%)",
        "color-action-text-on-off-disabled": "hsla(0, 0%, 100%, 0.32)",
        "color-action-text-on-off-hover": "hsl(219, 0%, 100%)",
        "color-action-text-on-off-normal": "hsl(0, 0%, 100%)",
        "color-action-text-on-off-read-only": "hsl(0, 0%, 100%)",
        "color-action-text-on-off-selected": "hsl(0, 0%, 0%)",
        "color-action-text-on-off-selected-disabled": "hsla(0, 0%, 0%, 0.32)",
        "color-action-text-secondary-disabled": "hsla(0, 0%, 100%, 0.48)",
        "color-action-text-secondary-normal": "hsl(0, 0%, 100%)",
        "color-action-text-secondary-selected": "hsl(0, 0%, 0%)",
        "color-action-text-secondary-selected-disabled": "hsla(0, 0%, 0%, 0.64)",
        "color-action-text-standard-active": "hsl(0, 0%, 0%)",
        "color-action-text-standard-disabled": "hsla(0, 0%, 100%, 0.48)",
        "color-action-text-standard-hover": "hsl(0, 0%, 100%)",
        "color-action-text-standard-normal": "hsl(0, 0%, 100%)",
        "color-action-text-standard-selected": "hsl(0, 0%, 0%)",
        "color-action-text-standard-selected-inactive": "hsl(0, 0%, 100%)",
        "color-action-text-standard-visited": "hsl(0, 0%, 100%)",
        "color-action-text-subtle-disabled": "hsla(0, 0%, 100%, 0.48)",
        "color-action-text-subtle-hover": "hsl(0, 0%, 100%)",
        "color-action-text-subtle-normal": "hsl(0, 0%, 100%)",
        "color-action-text-subtle-selected": "hsl(0, 0%, 0%)",
        "color-action-text-subtle-selected-inactive": "hsl(0, 0%, 100%)",
        "color-body-icon": "hsl(0, 0%, 100%)",
        "color-body-text": "hsl(0, 0%, 100%)",
        "color-container-background-0": "hsl(0, 0%, 0%)",
        "color-container-background-1": "hsl(0, 0%, 0%)",
        "color-container-background-2": "hsl(0, 0%, 0%)",
        "color-container-background-3": "hsl(0, 0%, 0%)",
        "color-container-background-4": "hsl(0, 0%, 100%)",
        "color-container-border-4": "hsl(0, 0%, 100%)",
        "color-dataviz-graph-alt1": "#8AC9FF",
        "color-dataviz-graph-alt2": "#FCE759",
        "color-dataviz-graph-alt3": "#E4C7FF",
        "color-dataviz-graph-alt4": "#FBB074",
        "color-dataviz-graph-alt5": "#76FABA",
        "color-dataviz-graph-alt6": "#F5BEBA",
        "color-dataviz-graph-alt7": "#B6F64E",
        "color-dataviz-graph-alt8": "#FFADDA",
        "color-dataviz-graph1": "#4AACFF",
        "color-dataviz-graph2": "#F1D700",
        "color-dataviz-graph3": "#C68AFF",
        "color-dataviz-graph4": "#F98E39",
        "color-dataviz-graph5": "#00D692",
        "color-dataviz-graph6": "#FF817A",
        "color-dataviz-graph7": "#7CBF00",
        "color-dataviz-graph8": "#FF6FBD",
        "color-dataviz-kpi-alt1": "#FF928A",
        "color-dataviz-kpi-alt3": "#F6E583",
        "color-dataviz-kpi-alt5": "#9AC473",
        "color-dataviz-kpi1": "#ff5e4d",
        "color-dataviz-kpi3": "#f2d94b",
        "color-dataviz-kpi5": "#7bb04a",
        "color-display-icon": "hsl(0, 0%, 100%)",
        "color-display-text": "hsl(0, 0%, 100%)",
        "color-heading-icon": "hsl(0, 0%, 100%)",
        "color-heading-text": "hsl(0, 0%, 100%)",
        "color-highlight-text": "hsl(205, 97%, 76%)",
        "color-highlight-text-inverse": "hsl(0, 0%, 0%)",
        "color-icon-neutral": "hsl(0, 0%, 100%)",
        "color-icon-primary": "hsl(205, 97%, 76%)",
        "color-icon-secondary": "hsl(329, 75%, 90%)",
        "color-label-text": "hsl(100, 100%, 100%)",
        "color-neutral": "hsl(205, 30%, 90%)",
        "color-primary": "hsl(205, 97%, 76%)",
        "color-secondary": "hsl(329, 75%, 90%)",
        "color-status-alert": "hsl(360, 80%, 80%)",
        "color-status-background-alert": "hsl(0, 0%, 0%)",
        "color-status-background-info": "hsl(0, 0%, 0%)",
        "color-status-background-neutral": "hsl(219, 0%, 0%)",
        "color-status-background-success": "hsl(0, 0%, 0%)",
        "color-status-background-warning": "hsl(0, 0%, 0%)",
        "color-status-border-alert": "hsl(360, 80%, 80%)",
        "color-status-border-info": "hsl(205, 80%, 75%)",
        "color-status-border-neutral": "hsl(219, 12%, 84%)",
        "color-status-border-success": "hsl(124, 60%, 75%)",
        "color-status-border-warning": "hsl(40, 80%, 75%)",
        "color-status-icon-alert": "hsl(360, 80%, 80%)",
        "color-status-icon-info": "hsl(205, 80%, 75%)",
        "color-status-icon-neutral": "hsl(219, 12%, 84%)",
        "color-status-icon-success": "hsl(124, 60%, 75%)",
        "color-status-icon-warning": "hsl(40, 80%, 75%)",
        "color-status-info": "hsl(205, 80%, 75%)",
        "color-status-neutral": "hsl(205, 30%, 90%)",
        "color-status-success": "hsl(124, 60%, 75%)",
        "color-status-text-alert": "hsl(360, 80%, 80%)",
        "color-status-text-info": "hsl(205, 80%, 75%)",
        "color-status-text-neutral": "hsl(219, 0%, 100%)",
        "color-status-text-success": "hsl(124, 60%, 75%)",
        "color-status-text-warning": "hsl(40, 80%, 75%)",
        "color-status-warning": "hsl(40, 80%, 75%)",
        "color-syntax-text-01": "hsl(0, 0%, 100%)",
        "color-syntax-text-02": "hsl(54, 66%, 53%)",
        "color-syntax-text-03": "hsl(27, 94%, 60%)",
        "color-syntax-text-04": "hsl(3, 100%, 73%)",
        "color-syntax-text-05": "hsl(328, 100%, 72%)",
        "color-syntax-text-06": "hsl(271, 100%, 77%)",
        "color-syntax-text-07": "hsl(212, 94%, 68%)",
        "color-syntax-text-08": "hsl(173, 72%, 43%)",
        "color-syntax-text-09": "hsl(81, 57%, 45%)",
        "color-syntax-text-attribute-name": "hsl(212, 94%, 68%)",
        "color-syntax-text-attribute-value": "hsl(3, 100%, 73%)",
        "color-syntax-text-boolean": "hsl(328, 100%, 72%)",
        "color-syntax-text-character-constant": "hsl(173, 72%, 43%)",
        "color-syntax-text-class-name": "hsl(173, 72%, 43%)",
        "color-syntax-text-comment": "hsl(81, 57%, 45%)",
        "color-syntax-text-control": "hsl(328, 100%, 72%)",
        "color-syntax-text-data": "hsl(27, 94%, 60%)",
        "color-syntax-text-declaration": "hsl(271, 100%, 77%)",
        "color-syntax-text-default": "hsl(0, 0%, 100%)",
        "color-syntax-text-function": "hsl(328, 100%, 72%)",
        "color-syntax-text-identifier": "hsl(0, 0%, 100%)",
        "color-syntax-text-keyword": "hsl(271, 100%, 77%)",
        "color-syntax-text-namespace": "hsl(173, 72%, 43%)",
        "color-syntax-text-normal": "hsl(0, 0%, 100%)",
        "color-syntax-text-numeric-constant": "hsl(173, 72%, 43%)",
        "color-syntax-text-operator": "hsl(212, 94%, 68%)",
        "color-syntax-text-proc-name": "hsl(212, 94%, 68%)",
        "color-syntax-text-property": "hsl(271, 100%, 77%)",
        "color-syntax-text-punctuation": "hsl(54, 66%, 53%)",
        "color-syntax-text-punctuation-brackets": "hsl(54, 66%, 53%)",
        "color-syntax-text-section": "hsl(212, 94%, 68%)",
        "color-syntax-text-separator": "hsl(0, 0%, 100%)",
        "color-syntax-text-source": "hsl(271, 100%, 77%)",
        "color-syntax-text-storage-type": "hsl(271, 100%, 77%)",
        "color-syntax-text-string": "hsl(3, 100%, 73%)",
        "color-syntax-text-tag": "hsl(271, 100%, 77%)",
        "color-syntax-text-variable": "hsl(212, 94%, 68%)",
        "color-tag-background-1": "hsla(205, 97%, 76%, 0.16)",
        "color-tag-background-2": "hsla(329, 75%, 90%, 0.16)",
        "color-tag-background-3": "hsla(205, 30%, 90%, 0.16)",
        "color-tag-border-1": "hsl(205, 97%, 76%)",
        "color-tag-border-2": "hsl(329, 75%, 90%)",
        "color-tag-border-3": "hsl(205, 30%, 90%)",
        "color-text-neutral": "hsl(0, 0%, 100%)",
        "color-text-neutral-inverse": "hsl(0, 0%, 0%)",
        "color-text-primary": "hsl(205, 97%, 76%)",
        "color-text-primary-inverse": "hsl(0, 0%, 0%)",
        "color-text-secondary": "hsl(329, 75%, 90%)",
        "color-thumbnail-fill-1": "hsl(205, 97%, 97%)",
        "color-thumbnail-fill-2": "hsl(205, 97%, 90%)",
        "color-thumbnail-fill-3": "hsl(205, 97%, 83%)",
        "color-thumbnail-fill-4": "hsl(205, 97%, 76%)",
        "color-zero-state-base-fill-1": "hsl(205, 30%, 0%)",
        "color-zero-state-base-fill-2": "hsl(205, 30%, 90%)",
        "color-zero-state-base-fill-3": "hsl(205, 30%, 55%)",
        "color-zero-state-modifier-fill-1": "hsl(205, 30%, 21%)",
        "color-zero-state-modifier-fill-2": "hsl(205, 97%, 76%)",
        "color-zero-state-modifier-fill-3": "hsl(205, 97%, 49%)",
        "color-zero-state-modifier-fill-4": "hsl(205, 30%, 31%)",
        "color-zero-state-modifier-fill-5": "hsl(205, 30%, 90%)",
        "duration-100": "100ms",
        "duration-1000": "1s",
        "duration-200": "200ms",
        "duration-250": "250ms",
        "duration-300": "300ms",
        "duration-400": "400ms",
        "duration-450": "450ms",
        "duration-500": "500ms",
        "duration-700": "700ms",
        "ease-in": "cubic-bezier(0, 0.5, 0.2, 1)",
        "ease-in-out": "cubic-bezier(0.5, 0, 0.2, 1)",
        "ease-out": "cubic-bezier(0.5, 0, 0.8, 1)",
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "Verdana, Helvetica, Arial, sans-serif",
        "font-family-secondary": "Verdana, Helvetica, Arial, sans-serif",
        "font-size-base-text": "16px",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": "0.75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-1": "30.8px",
        "font-size-line-height-heading-text-2": "28px",
        "font-size-line-height-heading-text-3": "25.2px",
        "font-size-line-height-heading-text-4": "22.4px",
        "font-size-line-height-heading-text-5": "19.6px",
        "font-size-line-height-heading-text-6": "16.8px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-size-ratio": "1.125",
        "font-size-ratio-major-second": "1.125",
        "font-size-ratio-major-third": "1.25",
        "font-size-ratio-minor-third": "1.2",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "2px",
        "font-space-letter-spacing-m": "1px",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "-1px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "font-space-word": "normal",
        "font-space-word-l": "2px",
        "font-space-word-m": "normal",
        "font-space-word-s": "1px",
        "font-style-expression": "normal",
        "font-style-expression-italic": "italic",
        "font-style-expression-normal": "normal",
        "font-style-expression-oblique": "oblique",
        "font-style-overflow-wrap": "anywhere",
        "font-style-overflow-wrap-anywhere": "anywhere",
        "font-style-overflow-wrap-break-word": "break-word",
        "font-style-overflow-wrap-normal": "normal",
        "font-style-text-transform": "none",
        "font-style-text-transform-capitalize": "capitalize",
        "font-style-text-transform-lowercase": "lowercase",
        "font-style-text-transform-none": "none",
        "font-style-text-transform-uppercase": "uppercase",
        "font-style-weight-300": "300",
        "font-style-weight-400": "400",
        "font-style-weight-500": "500",
        "font-style-weight-600": "600",
        "font-style-weight-700": "700",
        "font-style-word-break": "break-all",
        "font-style-word-break-break-all": "break-all",
        "font-style-word-break-break-word": "break-word",
        "font-style-word-break-keep-all": "keep-all",
        "font-style-word-break-normal": "normal",
        "shadow-depth-l": "0 8px 12px rgba(0, 0, 0, 0.04), 0 16px 24px rgba(0, 0, 0, 0.08)",
        "shadow-depth-m": "0 2px 4px rgba(0, 0, 0, 0.04), 0 8px 16px rgba(0, 0, 0, 0.08)",
        "shadow-depth-s": "0 2px 2px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xl": "0 16px 24px rgba(0, 0, 0, 0.04), 0 32px 48px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xs": "0 1px 2px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.08)",
        "size-action-border-width-focus": "4px",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-border-width-l": "3px",
        "size-border-width-m": "2px",
        "size-border-width-null": "0",
        "size-border-width-s": "1px",
        "size-container-l": "400px",
        "size-container-m": "320px",
        "size-container-null": "0",
        "size-container-s": "240px",
        "size-container-xl": "640px",
        "size-container-xs": "192px",
        "size-container-xxl": "960px",
        "size-container-xxs": "96px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "size-outline-width-l": "3px",
        "size-outline-width-m": "2px",
        "size-outline-width-s": "1px",
        "size-outline-width-xl": "4px",
        "size-zero-state-border-width": "0",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "2.875rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4.125rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.4375rem 0.8125rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem",
        "style-action-border-focus": "dotted"
    }
};

const HighDensityChineseVariantsLocalesTokens = {
    "name": "high-density-chinese-variants-locales",
    "selectors": ["[data-sas-theme='low-density']:lang(zh)", "[data-sas-theme='low-density']:lang(zh-cn)", "[data-sas-theme='low-density']:lang(zh-sg)", "[data-sas-theme='low-density']:lang(zh-hans)", "[data-sas-theme='low-density']:lang(zh-cn-pseudo)", "[data-sas-theme='low-density']:lang(zh-hk)", "[data-sas-theme='low-density']:lang(zh-tw)", "[data-sas-theme='low-density']:lang(zh-hant)"],
    "tokens": {
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": "0.75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-1": "30.8px",
        "font-size-line-height-body-text-2": "28px",
        "font-size-line-height-body-text-3": "25.2px",
        "font-size-line-height-body-text-4": "22.4px",
        "font-size-line-height-body-text-5": "21px",
        "font-size-line-height-body-text-6": "16.8px",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-1": "30.8px",
        "font-size-line-height-heading-text-2": "28px",
        "font-size-line-height-heading-text-3": "25.2px",
        "font-size-line-height-heading-text-4": "22.4px",
        "font-size-line-height-heading-text-5": "21px",
        "font-size-line-height-heading-text-6": "16.8px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "12px",
        "size-border-radius-m": "8px",
        "size-border-radius-s": "4px",
        "size-border-radius-xs": "2px",
        "size-border-radius-xxs": "1px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "2.875rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4.125rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "2rem 1rem",
        "space-stretch-m": "1.4375rem 0.8125rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const HighDensityEuroSlavicLocalesTokens = {
    "name": "high-density-euro-slavic-locales",
    "selectors": ["[data-sas-theme='high-density']:lang(en)"],
    "tokens": {
        "font-size-body-text-l": "0.875rem",
        "font-size-body-text-m": "0.75rem",
        "font-size-body-text-s": "0.6875rem",
        "font-size-body-text-xl": "0.9375rem",
        "font-size-body-text-xs": "0.5625rem",
        "font-size-body-text-xxl": "1.0625rem",
        "font-size-body-text-xxs": "0.5rem",
        "font-size-body-text-xxxl": "1.1875rem",
        "font-size-body-text-xxxs": "0.4375rem",
        "font-size-body-text-xxxxl": "1.375rem",
        "font-size-display-text-1": "3.875rem",
        "font-size-display-text-2": "3.0625rem",
        "font-size-display-text-3": "2.1875rem",
        "font-size-heading-text-1": "1.1875rem",
        "font-size-heading-text-2": "1.0625rem",
        "font-size-heading-text-3": "0.9375rem",
        "font-size-heading-text-4": "0.875",
        "font-size-heading-text-5": "0.75rem",
        "font-size-heading-text-6": "0.6875rem",
        "font-size-heading-text-l": "0.875rem",
        "font-size-heading-text-m": "0.75rem",
        "font-size-heading-text-s": "0.6875rem",
        "font-size-heading-text-xl": "0.9375rem",
        "font-size-heading-text-xxl": "1.0625rem",
        "font-size-heading-text-xxxl": "1.1875rem",
        "font-size-heading-text-xxxxl": "1.5rem",
        "font-size-heading-text-xxxxxl": "2.4375rem",
        "font-size-heading-text-xxxxxxl": "3.0625rem",
        "font-size-line-height-body-text-l": "19.6px",
        "font-size-line-height-body-text-m": "16.8px",
        "font-size-line-height-body-text-s": "15.4px",
        "font-size-line-height-body-text-xl": "21px",
        "font-size-line-height-body-text-xs": "12.6px",
        "font-size-line-height-body-text-xxl": "23.8px",
        "font-size-line-height-body-text-xxs": "11.2px",
        "font-size-line-height-body-text-xxxl": "26.6px",
        "font-size-line-height-body-text-xxxs": "9.8px",
        "font-size-line-height-body-text-xxxxl": "30.8px",
        "font-size-line-height-display-text-1": "86.8px",
        "font-size-line-height-display-text-2": "68.6px",
        "font-size-line-height-display-text-3": "49px",
        "font-size-line-height-heading-text-1": "26.6px",
        "font-size-line-height-heading-text-2": "23.8px",
        "font-size-line-height-heading-text-3": "21px",
        "font-size-line-height-heading-text-4": "19.6px",
        "font-size-line-height-heading-text-5": "16.8px",
        "font-size-line-height-heading-text-6": "15.4px",
        "font-size-line-height-heading-text-l": "19.6px",
        "font-size-line-height-heading-text-m": "16.8px",
        "font-size-line-height-heading-text-s": "15.4px",
        "font-size-line-height-heading-text-xl": "21px",
        "font-size-line-height-heading-text-xxl": "23.8px",
        "font-size-line-height-heading-text-xxxl": "26.6px",
        "font-size-line-height-heading-text-xxxxl": "33.6px",
        "font-size-line-height-heading-text-xxxxxl": "68.6px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "12px",
        "size-border-radius-m": "8px",
        "size-border-radius-s": "4px",
        "size-border-radius-xs": "2px",
        "size-border-radius-xxs": "1px",
        "size-icon-l": "0.875rem",
        "size-icon-m": "0.75rem",
        "size-icon-s": "0.6875rem",
        "size-icon-xl": "0.9375rem",
        "size-icon-xs": "0.6875rem",
        "size-icon-xxl": "1.0625rem",
        "size-icon-xxs": "0.6875rem",
        "size-icon-xxxl": "1.1875rem",
        "size-icon-xxxs": "0.6875rem",
        "size-icon-xxxxl": "1.375rem",
        "space-base-l": "1.25rem",
        "space-base-m": "0.875rem",
        "space-base-null": "0",
        "space-base-s": "0.4375rem",
        "space-base-size": "1rem",
        "space-base-xl": "1.75rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.25rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.5rem",
        "space-base-xxxxl": "3.1875rem",
        "space-base-xxxxxl": "3.625rem",
        "space-block-l": "1.25rem",
        "space-block-m": "0.875rem",
        "space-block-s": "0.4375rem",
        "space-block-xl": "1.5rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.25rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.5rem",
        "space-block-xxxxl": "3.1875rem",
        "space-block-xxxxxl": "3.625rem",
        "space-inline-l": "1.25rem",
        "space-inline-m": "0.875rem",
        "space-inline-s": "0.4375rem",
        "space-inline-xl": "1.75rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.25rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "2.5rem",
        "space-inline-xxxxl": "3.1875rem",
        "space-inline-xxxxxl": "3.625rem",
        "space-squish-l": "0.6875rem 1.25rem",
        "space-squish-m": "0.4375rem 0.875rem",
        "space-squish-s": "0.25rem 04375rem",
        "space-squish-xl": "0.875rem 1.75rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.125rem 2.25rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.75rem 0.875rem",
        "space-stretch-m": "1.25rem 0.6875rem",
        "space-stretch-s": "0.4375rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const HighDensityMenaAsianLocalesTokens = {
    "name": "high-density-mena-asian-locales",
    "selectors": ["[data-sas-theme='high-density']:lang(ar)", "[data-sas-theme='high-density']:lang(ar-xx)", "[data-sas-theme='high-density']:lang(he)", "[data-sas-theme='high-density']:lang(jp)", "[data-sas-theme='high-density']:lang(ko)", "[data-sas-theme='high-density']:lang(th)", "[data-sas-theme='high-density']:lang(vi)", "[data-sas-theme='high-density']:lang(vi-VN)"],
    "tokens": {
        "font-size-body-text-l": "0.875rem",
        "font-size-body-text-m": "0.75rem",
        "font-size-body-text-s": "0.6875rem",
        "font-size-body-text-xl": "0.9375rem",
        "font-size-body-text-xs": "0.5625rem",
        "font-size-body-text-xxl": "1.0625rem",
        "font-size-body-text-xxs": "0.5rem",
        "font-size-body-text-xxxl": "1.1875rem",
        "font-size-body-text-xxxs": "0.4375rem",
        "font-size-body-text-xxxxl": "1.375rem",
        "font-size-display-text-1": "3.875rem",
        "font-size-display-text-2": "3.0625rem",
        "font-size-display-text-3": "2.1875rem",
        "font-size-heading-text-1": "1.1875rem",
        "font-size-heading-text-2": "1.0625rem",
        "font-size-heading-text-3": "0.9375rem",
        "font-size-heading-text-4": "0.875rem",
        "font-size-heading-text-5": "0.75rem",
        "font-size-heading-text-6": "0.6875rem",
        "font-size-heading-text-l": "0.875rem",
        "font-size-heading-text-m": "0.75rem",
        "font-size-heading-text-s": "0.6875rem",
        "font-size-heading-text-xl": "0.9375rem",
        "font-size-heading-text-xxl": "1.0625rem",
        "font-size-heading-text-xxxl": "1.1875rem",
        "font-size-heading-text-xxxxl": "1.5rem",
        "font-size-heading-text-xxxxxl": "2.4375rem",
        "font-size-heading-text-xxxxxxl": "3.0625rem",
        "font-size-line-height-body-text-l": "19.6px",
        "font-size-line-height-body-text-m": "16.8px",
        "font-size-line-height-body-text-s": "15.4px",
        "font-size-line-height-body-text-xl": "21px",
        "font-size-line-height-body-text-xs": "12.6px",
        "font-size-line-height-body-text-xxl": "23.8px",
        "font-size-line-height-body-text-xxs": "11.2px",
        "font-size-line-height-body-text-xxxl": "26.6px",
        "font-size-line-height-body-text-xxxs": "9.8px",
        "font-size-line-height-body-text-xxxxl": "30.8px",
        "font-size-line-height-display-text-1": "86.8px",
        "font-size-line-height-display-text-2": "68.6px",
        "font-size-line-height-display-text-3": "49px",
        "font-size-line-height-heading-text-1": "26.6px",
        "font-size-line-height-heading-text-2": "23.8px",
        "font-size-line-height-heading-text-3": "21px",
        "font-size-line-height-heading-text-4": "19.6px",
        "font-size-line-height-heading-text-5": "16.8px",
        "font-size-line-height-heading-text-6": "15.4px",
        "font-size-line-height-heading-text-l": "19.6px",
        "font-size-line-height-heading-text-m": "16.8px",
        "font-size-line-height-heading-text-s": "15.4px",
        "font-size-line-height-heading-text-xl": "21px",
        "font-size-line-height-heading-text-xxl": "23.8px",
        "font-size-line-height-heading-text-xxxl": "26.6px",
        "font-size-line-height-heading-text-xxxxl": "33.6px",
        "font-size-line-height-heading-text-xxxxxl": "68.6px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "12px",
        "size-border-radius-m": "8px",
        "size-border-radius-s": "4px",
        "size-border-radius-xs": "2px",
        "size-border-radius-xxs": "1px",
        "size-icon-l": "0.875rem",
        "size-icon-m": "0.75rem",
        "size-icon-s": "0.6875rem",
        "size-icon-xl": "0.9375rem",
        "size-icon-xs": "0.6875rem",
        "size-icon-xxl": "1.0625rem",
        "size-icon-xxs": "0.6875rem",
        "size-icon-xxxl": "1.1875rem",
        "size-icon-xxxs": "0.6875rem",
        "size-icon-xxxxl": "1.375rem",
        "space-base-l": "1.25rem",
        "space-base-m": "0.875rem",
        "space-base-null": "0",
        "space-base-s": "0.4375rem",
        "space-base-size": "1rem",
        "space-base-xl": "1.75rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.25rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.5rem",
        "space-base-xxxxl": "3.1875rem",
        "space-base-xxxxxl": "3.625rem",
        "space-block-l": "1.25rem",
        "space-block-m": "0.875rem",
        "space-block-s": "0.4375rem",
        "space-block-xl": "1.75rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.25rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.5rem",
        "space-block-xxxxl": "3.1875rem",
        "space-block-xxxxxl": "3.625rem",
        "space-inline-l": "1.25rem",
        "space-inline-m": "0.875rem",
        "space-inline-s": "0.4375rem",
        "space-inline-xl": "1.75rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.25rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "2.5rem",
        "space-inline-xxxxl": "3.1875rem",
        "space-inline-xxxxxl": "3.625rem",
        "space-squish-l": "0.6875rem 1.25rem",
        "space-squish-m": "0.4375rem 0.875rem",
        "space-squish-s": "0.25rem 0.4375rem",
        "space-squish-xl": "0.875rem .75rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.125rem 2.25rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.75rem 0.875rem",
        "space-stretch-m": "1.25rem 0.6875rem",
        "space-stretch-s": "0.4375rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const HighDensityTokens = {
    "name": "high-density",
    "selectors": ["[data-sas-theme='high-density']"],
    "tokens": {
        "font-size-body-text-l": "0.875rem",
        "font-size-body-text-m": "0.75rem",
        "font-size-body-text-s": "0.6875rem",
        "font-size-body-text-xl": "0.9375rem",
        "font-size-body-text-xs": "0.5625rem",
        "font-size-body-text-xxl": "1.0625rem",
        "font-size-body-text-xxs": "0.5rem",
        "font-size-body-text-xxxl": "1.1875rem",
        "font-size-body-text-xxxs": "0.4375rem",
        "font-size-body-text-xxxxl": "1.375rem",
        "font-size-display-text-1": "3.875rem",
        "font-size-display-text-2": "3.0625rem",
        "font-size-display-text-3": "2.1875rem",
        "font-size-heading-text-1": "1.1875rem",
        "font-size-heading-text-2": "1.0625rem",
        "font-size-heading-text-3": "0.9375rem",
        "font-size-heading-text-4": "0.875",
        "font-size-heading-text-5": "0.75rem",
        "font-size-heading-text-6": "0.6875rem",
        "font-size-heading-text-l": "0.875rem",
        "font-size-heading-text-m": "0.75rem",
        "font-size-heading-text-s": "0.6875rem",
        "font-size-heading-text-xl": "0.9375rem",
        "font-size-heading-text-xxl": "1.0625rem",
        "font-size-heading-text-xxxl": "1.1875rem",
        "font-size-heading-text-xxxxl": "1.5rem",
        "font-size-heading-text-xxxxxl": "2.4375rem",
        "font-size-heading-text-xxxxxxl": "3.0625rem",
        "font-size-line-height-body-text-l": "19.6px",
        "font-size-line-height-body-text-m": "16.8px",
        "font-size-line-height-body-text-s": "15.4px",
        "font-size-line-height-body-text-xl": "21px",
        "font-size-line-height-body-text-xs": "12.6px",
        "font-size-line-height-body-text-xxl": "23.8px",
        "font-size-line-height-body-text-xxs": "11.2px",
        "font-size-line-height-body-text-xxxl": "26.6px",
        "font-size-line-height-body-text-xxxs": "9.8px",
        "font-size-line-height-body-text-xxxxl": "30.8px",
        "font-size-line-height-display-text-1": "86.8px",
        "font-size-line-height-display-text-2": "68.6px",
        "font-size-line-height-display-text-3": "49px",
        "font-size-line-height-heading-text-1": "26.6px",
        "font-size-line-height-heading-text-2": "23.8px",
        "font-size-line-height-heading-text-3": "21px",
        "font-size-line-height-heading-text-4": "19.6px",
        "font-size-line-height-heading-text-5": "16.8px",
        "font-size-line-height-heading-text-6": "15.4px",
        "font-size-line-height-heading-text-l": "19.6px",
        "font-size-line-height-heading-text-m": "16.8px",
        "font-size-line-height-heading-text-s": "15.4px",
        "font-size-line-height-heading-text-xl": "21px",
        "font-size-line-height-heading-text-xxl": "23.8px",
        "font-size-line-height-heading-text-xxxl": "26.6px",
        "font-size-line-height-heading-text-xxxxl": "33.6px",
        "font-size-line-height-heading-text-xxxxxl": "68.6px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "12px",
        "size-border-radius-m": "8px",
        "size-border-radius-s": "4px",
        "size-border-radius-xs": "2px",
        "size-border-radius-xxs": "1px",
        "size-icon-l": "0.875rem",
        "size-icon-m": "0.75rem",
        "size-icon-s": "0.6875rem",
        "size-icon-xl": "0.9375rem",
        "size-icon-xs": "0.6875rem",
        "size-icon-xxl": "1.0625rem",
        "size-icon-xxs": "0.6875rem",
        "size-icon-xxxl": "1.1875rem",
        "size-icon-xxxs": "0.6875rem",
        "size-icon-xxxxl": "1.375rem",
        "space-base-l": "1.25rem",
        "space-base-m": "0.875rem",
        "space-base-null": "0",
        "space-base-s": "0.4375rem",
        "space-base-size": "1rem",
        "space-base-xl": "1.75rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.25rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.5rem",
        "space-base-xxxxl": "3.1875rem",
        "space-base-xxxxxl": "3.625rem",
        "space-block-l": "1.25rem",
        "space-block-m": "0.875rem",
        "space-block-s": "0.4375rem",
        "space-block-xl": "1.5rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.25rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.5rem",
        "space-block-xxxxl": "3.1875rem",
        "space-block-xxxxxl": "3.625rem",
        "space-inline-l": "1.25rem",
        "space-inline-m": "0.875rem",
        "space-inline-s": "0.4375rem",
        "space-inline-xl": "1.75rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.25rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "2.5rem",
        "space-inline-xxxxl": "3.1875rem",
        "space-inline-xxxxxl": "3.625rem",
        "space-squish-l": "0.6875rem 1.25rem",
        "space-squish-m": "0.4375rem 0.875rem",
        "space-squish-s": "0.25rem 04375rem",
        "space-squish-xl": "0.875rem 1.75rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.125rem 2.25rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.75rem 0.875rem",
        "space-stretch-m": "1.25rem 0.6875rem",
        "space-stretch-s": "0.4375rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const JapaneseTokens = {
    "name": "japanese",
    "selectors": [":lang(jp)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'Osaka', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'MS PGothic', 'Noto Sans JP', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'AvenirNext', 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'Osaka', 'メイリオ', 'Meiryo', 'ＭＳ Ｐゴシック', 'MS PGothic', 'Noto Sans JP', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": ".75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-1": "33px",
        "font-size-line-height-heading-text-2": "30px",
        "font-size-line-height-heading-text-3": "27px",
        "font-size-line-height-heading-text-4": "24px",
        "font-size-line-height-heading-text-5": "21px",
        "font-size-line-height-heading-text-6": "18px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.5rem 0.75rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const KoreanTokens = {
    "name": "korean",
    "selectors": [":lang(ko)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', '맑은 고딕', 'Malgun Gothic', 'Apple SD Gothic Neo', 'NanumBarunGothic', '굴림', 'Gulim', '돋움', 'Dotum', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'AvenirNext', '맑은 고딕', 'Malgun Gothic', 'Apple SD Gothic Neo', 'NanumBarunGothic', '굴림', 'Gulim', '돋움', 'Dotum', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": ".75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-1": "33px",
        "font-size-line-height-heading-text-2": "30px",
        "font-size-line-height-heading-text-3": "27px",
        "font-size-line-height-heading-text-4": "24px",
        "font-size-line-height-heading-text-5": "21px",
        "font-size-line-height-heading-text-6": "18px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "font-style-expression-italic": "normal",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.5rem 0.75rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const LightTokens = {
    "name": "light",
    "selectors": [":root", "[data-sas-theme='light']"],
    "tokens": {
        "color-action-background-control-alert": "hsl(0, 100%, 100%)",
        "color-action-background-control-disabled": "hsl(0, 100%, 100%)",
        "color-action-background-control-hover": "hsl(0, 100%, 100%)",
        "color-action-background-control-non-editable": "hsla(216, 13%, 53%, 0.08)",
        "color-action-background-control-normal": "hsl(0, 100%, 100%)",
        "color-action-background-control-placeholder": "hsl(0, 100%, 100%)",
        "color-action-background-control-primary": "hsl(205, 97%, 35%)",
        "color-action-background-control-read-only": "hsl(0, 100%, 100%)",
        "color-action-background-control-selected": "hsl(0, 100%, 100%)",
        "color-action-background-control-warning": "hsl(0, 100%, 100%)",
        "color-action-background-emphasis-active": "hsl(205, 97%, 35%)",
        "color-action-background-emphasis-disabled": "hsla(205, 97%, 35%, 0.24)",
        "color-action-background-emphasis-hover": "hsl(205, 97%, 35%)",
        "color-action-background-emphasis-normal": "hsl(205, 97%, 35%)",
        "color-action-background-emphasis-selected": "hsl(205, 97%, 35%)",
        "color-action-background-emphasis-visited": "hsl(205, 97%, 35%)",
        "color-action-background-focus": "hsl(205, 97%, 24%)",
        "color-action-background-focus-inverse": "hsl(0, 100%, 100%)",
        "color-action-background-on-off-disabled": "hsl(0, 100%, 100%)",
        "color-action-background-on-off-hover": "hsla(216, 13%, 53%, 0.16)",
        "color-action-background-on-off-normal": "hsl(0, 100%, 100%)",
        "color-action-background-on-off-read-only": "hsla(216, 13%, 53%, 0.08)",
        "color-action-background-on-off-selected": "hsl(329, 75%, 30%)",
        "color-action-background-on-off-selected-disabled": "hsla(329, 75%, 30%, 0.16)",
        "color-action-background-secondary-disabled": "hsla(216, 13%, 53%, 0.08)",
        "color-action-background-secondary-normal": "hsla(216, 13%, 53%, 0.08)",
        "color-action-background-secondary-selected": "hsla(329, 75%, 30%, 0.24)",
        "color-action-background-secondary-selected-disabled": "hsla(329, 75%, 30%, 0.08)",
        "color-action-background-standard-active": "hsla(216, 13%, 53%, 0.24)",
        "color-action-background-standard-disabled": "hsla(216, 13%, 53%, 0.08)",
        "color-action-background-standard-hover": "hsla(216, 13%, 53%, 0.16)",
        "color-action-background-standard-normal": "hsla(216, 13%, 53%, 0.08)",
        "color-action-background-standard-selected": "hsla(216, 13%, 53%, 0.24)",
        "color-action-background-standard-selected-inactive": "hsla(216, 13%, 53%, 0.16)",
        "color-action-background-standard-visited": "hsl(219, 94%, 98%)",
        "color-action-background-subtle-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-background-subtle-hover": "hsla(216, 13%, 53%, 0.16)",
        "color-action-background-subtle-normal": "hsla(0, 100%, 100%, 0)",
        "color-action-background-subtle-selected": "hsla(216, 13%, 53%, 0.24)",
        "color-action-background-subtle-selected-inactive": "hsla(216, 13%, 53%, 0.16)",
        "color-action-border-bottom-control-alert": "hsl(360, 100%, 42%)",
        "color-action-border-bottom-control-hover": "hsl(216, 13%, 53%)",
        "color-action-border-bottom-control-normal": "hsl(216, 13%, 53%)",
        "color-action-border-bottom-control-selected": "hsl(205, 97%, 35%)",
        "color-action-border-bottom-control-warning": "hsl(40, 100%, 28%)",
        "color-action-border-control-alert": "hsl(360, 100%, 42%)",
        "color-action-border-control-disabled": "hsla(216, 13%, 53%, 0.32)",
        "color-action-border-control-hover": "hsl(216, 13%, 53%)",
        "color-action-border-control-normal": "hsl(216, 13%, 53%)",
        "color-action-border-control-placeholder": "hsl(216, 13%, 53%)",
        "color-action-border-control-read-only": "hsla(0, 100%, 100%, 0)",
        "color-action-border-control-selected": "hsl(205, 97%, 35%)",
        "color-action-border-control-warning": "hsl(40, 100%, 28%)",
        "color-action-border-emphasis-active": "hsl(205, 97%, 35%)",
        "color-action-border-emphasis-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-border-emphasis-hover": "hsl(205, 97%, 35%)",
        "color-action-border-emphasis-normal": "hsl(205, 97%, 35%)",
        "color-action-border-emphasis-selected": "hsl(205, 97%, 35%)",
        "color-action-border-emphasis-visited": "hsl(205, 97%, 35%)",
        "color-action-border-focus": "hsl(205, 97%, 24%)",
        "color-action-border-focus-inverse": "hsl(212, 0%, 100%)",
        "color-action-border-on-off-disabled": "hsla(216, 13%, 53%, 0.32)",
        "color-action-border-on-off-hover": "hsl(216, 13%, 53%)",
        "color-action-border-on-off-normal": "hsl(216, 13%, 53%)",
        "color-action-border-on-off-read-only": "hsl(216, 13%, 53%)",
        "color-action-border-on-off-selected": "hsl(329, 75%, 30%)",
        "color-action-border-on-off-selected-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-border-secondary-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-border-secondary-normal": "hsla(216, 13%, 53%, 0.24)",
        "color-action-border-secondary-selected": "hsl(329, 75%, 30%)",
        "color-action-border-secondary-selected-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-border-standard-active": "hsl(0, 0%, 0%)",
        "color-action-border-standard-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-border-standard-hover": "hsl(216, 13%, 53%)",
        "color-action-border-standard-normal": "hsla(216, 13%, 53%, 0.24)",
        "color-action-border-standard-selected": "hsl(0, 0%, 0%)",
        "color-action-border-standard-selected-inactive": "hsla(0, 100%, 100%, 0)",
        "color-action-border-standard-visited": "hsl(216, 13%, 53%)",
        "color-action-border-subtle-disabled": "hsla(0, 100%, 100%, 0)",
        "color-action-border-subtle-hover": "hsla(0, 100%, 100%, 0)",
        "color-action-border-subtle-normal": "hsla(0, 100%, 100%, 0)",
        "color-action-border-subtle-selected": "hsla(0, 100%, 100%, 0)",
        "color-action-border-subtle-selected-inactive": "hsla(0, 100%, 100%, 0)",
        "color-action-focus": "hsl(205, 97%, 24%)",
        "color-action-icon-control-alert": "hsl(360, 100%, 42%)",
        "color-action-icon-control-disabled": "hsla(0, 0%, 0%, 0.32)",
        "color-action-icon-control-hover": "hsl(0, 0%, 0%)",
        "color-action-icon-control-normal": "hsl(0, 0%, 0%)",
        "color-action-icon-control-read-only": "hsl(0, 0%, 0%)",
        "color-action-icon-control-selected": "hsl(0, 0%, 0%)",
        "color-action-icon-control-warning": "hsl(40, 100%, 28%)",
        "color-action-icon-emphasis-active": "hsla(0, 100%, 100%, 0.6)",
        "color-action-icon-emphasis-disabled": "hsla(0, 100%, 100%, 0.64)",
        "color-action-icon-emphasis-hover": "hsl(0, 100%, 100%)",
        "color-action-icon-emphasis-normal": "hsl(0, 100%, 100%)",
        "color-action-icon-emphasis-selected": "hsla(0, 100%, 100%, 0.6)",
        "color-action-icon-emphasis-visited": "hsl(212, 0%, 100%)",
        "color-action-icon-on-off-disabled": "hsla(0, 0%, 0%, 0.32)",
        "color-action-icon-on-off-hover": "hsl(0, 0%, 0%)",
        "color-action-icon-on-off-normal": "hsl(0, 0%, 0%)",
        "color-action-icon-on-off-read-only": "hsl(0, 0%, 0%)",
        "color-action-icon-on-off-selected": "hsl(0, 100%, 100%)",
        "color-action-icon-on-off-selected-disabled": "hsla(0, 100%, 100%, 0.64)",
        "color-action-icon-standard-active": "hsl(0, 0%, 0%)",
        "color-action-icon-standard-disabled": "hsla(0, 0%, 0%, 0.32)",
        "color-action-icon-standard-hover": "hsl(0, 0%, 0%)",
        "color-action-icon-standard-normal": "hsl(0, 0%, 0%)",
        "color-action-icon-standard-selected": "hsl(0, 0%, 0%)",
        "color-action-icon-standard-selected-inactive": "hsl(0, 0%, 0%)",
        "color-action-icon-standard-visited": "hsl(0, 0%, 0%)",
        "color-action-icon-subtle-disabled": "hsla(0, 0%, 0%, 0.32)",
        "color-action-icon-subtle-hover": "hsl(0, 0%, 0%)",
        "color-action-icon-subtle-normal": "hsl(0, 0%, 0%)",
        "color-action-icon-subtle-selected": "hsl(0, 0%, 0%)",
        "color-action-icon-subtle-selected-inactive": "hsl(0, 0%, 0%)",
        "color-action-link-active": "hsl(0, 0%, 0%)",
        "color-action-link-hover": "hsl(0, 0%, 0%)",
        "color-action-link-normal": "hsl(0, 0%, 0%)",
        "color-action-link-visited": "hsl(0, 0%, 0%)",
        "color-action-text-control-alert": "hsl(0, 0%, 0%)",
        "color-action-text-control-disabled": "hsla(0, 0%, 0%, 0.32)",
        "color-action-text-control-hover": "hsl(0, 0%, 0%)",
        "color-action-text-control-normal": "hsl(0, 0%, 0%)",
        "color-action-text-control-placeholder": "hsl(218, 13%, 46%)",
        "color-action-text-control-read-only": "hsl(0, 0%, 0%)",
        "color-action-text-control-selected": "hsl(0, 0%, 0%)",
        "color-action-text-control-warning": "hsl(0, 0%, 0%)",
        "color-action-text-emphasis-active": "hsla(0, 100%, 100%, 0.6)",
        "color-action-text-emphasis-disabled": "hsla(0, 100%, 100%, 0.64)",
        "color-action-text-emphasis-hover": "hsl(0, 100%, 100%)",
        "color-action-text-emphasis-normal": "hsl(0, 100%, 100%)",
        "color-action-text-emphasis-selected": "hsl(0, 100%, 100%)",
        "color-action-text-emphasis-visited": "hsl(212, 0%, 100%)",
        "color-action-text-on-off-disabled": "hsla(0, 0%, 0%, 0.32)",
        "color-action-text-on-off-hover": "hsl(0, 0%, 0%)",
        "color-action-text-on-off-normal": "hsl(0, 0%, 0%)",
        "color-action-text-on-off-read-only": "hsl(0, 0%, 0%)",
        "color-action-text-on-off-selected": "hsl(0, 100%, 100%)",
        "color-action-text-on-off-selected-disabled": "hsla(0, 100%, 100%, 0.64)",
        "color-action-text-secondary-disabled": "hsla(0, 0%, 0%, 0.32)",
        "color-action-text-secondary-normal": "hsl(0, 0%, 0%)",
        "color-action-text-secondary-selected": "hsl(329, 75%, 30%)",
        "color-action-text-secondary-selected-disabled": "hsla(329, 75%, 30%, 0.32)",
        "color-action-text-standard-active": "hsl(0, 0%, 0%)",
        "color-action-text-standard-disabled": "hsla(0, 0%, 0%, 0.32)",
        "color-action-text-standard-hover": "hsl(0, 0%, 0%)",
        "color-action-text-standard-normal": "hsl(0, 0%, 0%)",
        "color-action-text-standard-selected": "hsl(0, 0%, 0%)",
        "color-action-text-standard-selected-inactive": "hsl(0, 0%, 0%)",
        "color-action-text-standard-visited": "hsl(0, 0%, 0%)",
        "color-action-text-subtle-disabled": "hsla(0, 0%, 0%, 0.32)",
        "color-action-text-subtle-hover": "hsl(0, 0%, 0%)",
        "color-action-text-subtle-normal": "hsl(0, 0%, 0%)",
        "color-action-text-subtle-selected": "hsl(0, 0%, 0%)",
        "color-action-text-subtle-selected-inactive": "hsl(0, 0%, 0%)",
        "color-body-icon": "hsl(0, 0%, 0%)",
        "color-body-text": "hsl(0, 0%, 0%)",
        "color-container-background-0": "hsl(219, 0%, 100%)",
        "color-container-background-1": "hsl(219, 12%, 98%)",
        "color-container-background-2": "hsl(219, 12%, 96%)",
        "color-container-background-3": "hsl(205, 97%, 41%)",
        "color-container-background-4": "hsl(216, 13%, 88%)",
        "color-container-border-4": "hsl(216, 13%, 88%)",
        "color-dataviz-graph-alt1": "#287FC7",
        "color-dataviz-graph-alt2": "#C79F27",
        "color-dataviz-graph-alt3": "#7358C7",
        "color-dataviz-graph-alt4": "#C7651C",
        "color-dataviz-graph-alt5": "#1F9999",
        "color-dataviz-graph-alt6": "#A64141",
        "color-dataviz-graph-alt7": "#0E7D55",
        "color-dataviz-graph-alt8": "#C75793",
        "color-dataviz-graph1": "#33a3ff",
        "color-dataviz-graph2": "#fc3",
        "color-dataviz-graph3": "#9470ff",
        "color-dataviz-graph4": "#ff8324",
        "color-dataviz-graph5": "#29d1d1",
        "color-dataviz-graph6": "#dc5656",
        "color-dataviz-graph7": "#15b77b",
        "color-dataviz-graph8": "#ff70bc",
        "color-dataviz-kpi-alt1": "#A64141",
        "color-dataviz-kpi-alt3": "#C79F27",
        "color-dataviz-kpi-alt5": "#0E7D55",
        "color-dataviz-kpi1": "#dd5757",
        "color-dataviz-kpi3": "#ffcc32",
        "color-dataviz-kpi5": "#15b57b",
        "color-display-icon": "hsl(0, 0%, 0%)",
        "color-display-text": "hsl(0, 0%, 0%)",
        "color-heading-icon": "hsl(0, 0%, 0%)",
        "color-heading-text": "hsl(0, 0%, 0%)",
        "color-highlight-text": "hsl(205, 97%, 35%)",
        "color-highlight-text-inverse": "hsl(0, 100%, 100%)",
        "color-icon-neutral": "hsl(0, 0%, 0%)",
        "color-icon-primary": "hsl(205, 97%, 35%)",
        "color-icon-secondary": "hsl(329, 75%, 30%)",
        "color-label-text": "hsl(218, 13%, 46%)",
        "color-neutral": "hsl(216, 13%, 53%)",
        "color-primary": "hsl(205, 97%, 35%)",
        "color-secondary": "hsl(329, 75%, 30%)",
        "color-status-alert": "hsl(360, 100%, 42%)",
        "color-status-background-alert": "hsl(0, 100%, 100%)",
        "color-status-background-info": "hsl(0, 100%, 100%)",
        "color-status-background-neutral": "hsl(219, 12%, 98%)",
        "color-status-background-success": "hsl(0, 100%, 100%)",
        "color-status-background-warning": "hsl(0, 100%, 100%)",
        "color-status-border-alert": "hsl(360, 100%, 42%)",
        "color-status-border-info": "hsl(205, 99%, 37%)",
        "color-status-border-neutral": "hsl(219, 12%, 48%)",
        "color-status-border-success": "hsl(124, 85%, 26%)",
        "color-status-border-warning": "hsl(40, 100%, 28%)",
        "color-status-icon-alert": "hsl(360, 100%, 42%)",
        "color-status-icon-info": "hsl(205, 99%, 37%)",
        "color-status-icon-neutral": "hsl(219, 12%, 48%)",
        "color-status-icon-success": "hsl(124, 85%, 26%)",
        "color-status-icon-warning": "hsl(40, 100%, 28%)",
        "color-status-info": "hsl(205, 99%, 37%)",
        "color-status-neutral": "hsl(216, 13%, 45%)",
        "color-status-success": "hsl(124, 85%, 26%)",
        "color-status-text-alert": "hsl(360, 100%, 42%)",
        "color-status-text-info": "hsl(205, 99%, 37%)",
        "color-status-text-neutral": "hsl(219, 0%, 0%)",
        "color-status-text-success": "hsl(124, 85%, 26%)",
        "color-status-text-warning": "hsl(40, 100%, 28%)",
        "color-status-warning": "hsl(40, 100%, 28%)",
        "color-syntax-text-01": "hsl(223, 11%, 12%)",
        "color-syntax-text-02": "hsl(219, 12%, 48%)",
        "color-syntax-text-03": "hsl(25, 56%, 44%)",
        "color-syntax-text-04": "hsl(7, 44%, 39%)",
        "color-syntax-text-05": "hsl(267, 35%, 44%)",
        "color-syntax-text-06": "hsl(212, 58%, 49%)",
        "color-syntax-text-07": "hsl(212, 57%, 31%)",
        "color-syntax-text-08": "hsl(169, 37%, 37%)",
        "color-syntax-text-09": "hsl(79, 51%, 33%)",
        "color-syntax-text-attribute-name": "hsl(212, 57%, 31%)",
        "color-syntax-text-attribute-value": "hsl(7, 44%, 39%)",
        "color-syntax-text-boolean": "hsl(267, 35%, 44%)",
        "color-syntax-text-character-constant": "hsl(169, 37%, 37%)",
        "color-syntax-text-class-name": "hsl(169, 37%, 37%)",
        "color-syntax-text-comment": "hsl(79, 51%, 33%)",
        "color-syntax-text-control": "hsl(267, 35%, 44%)",
        "color-syntax-text-data": "hsl(25, 56%, 44%)",
        "color-syntax-text-declaration": "hsl(212, 58%, 49%)",
        "color-syntax-text-default": "hsl(223, 11%, 12%)",
        "color-syntax-text-function": "hsl(267, 35%, 44%)",
        "color-syntax-text-identifier": "hsl(223, 11%, 12%)",
        "color-syntax-text-keyword": "hsl(212, 58%, 49%)",
        "color-syntax-text-namespace": "hsl(169, 37%, 37%)",
        "color-syntax-text-normal": "hsl(223, 11%, 12%)",
        "color-syntax-text-numeric-constant": "hsl(169, 37%, 37%)",
        "color-syntax-text-operator": "hsl(212, 57%, 31%)",
        "color-syntax-text-proc-name": "hsl(212, 57%, 31%)",
        "color-syntax-text-property": "hsl(212, 58%, 49%)",
        "color-syntax-text-punctuation": "hsl(219, 12%, 48%)",
        "color-syntax-text-punctuation-brackets": "hsl(219, 12%, 48%)",
        "color-syntax-text-section": "hsl(212, 57%, 31%)",
        "color-syntax-text-separator": "hsl(223, 11%, 12%)",
        "color-syntax-text-source": "hsl(212, 58%, 49%)",
        "color-syntax-text-storage-type": "hsl(212, 58%, 49%)",
        "color-syntax-text-string": "hsl(7, 44%, 39%)",
        "color-syntax-text-tag": "hsl(212, 58%, 49%)",
        "color-syntax-text-variable": "hsl(212, 57%, 31%)",
        "color-tag-background-1": "hsla(205, 97%, 35%, 0.16)",
        "color-tag-background-2": "hsla(329, 75%, 30%, 0.16)",
        "color-tag-background-3": "hsla(216, 13%, 53%, 0.16)",
        "color-tag-border-1": "hsl(205, 97%, 35%)",
        "color-tag-border-2": "hsl(329, 75%, 30%)",
        "color-tag-border-3": "hsl(216, 13%, 53%)",
        "color-text-neutral": "hsl(0, 0%, 0%)",
        "color-text-neutral-inverse": "hsl(0, 100%, 100%)",
        "color-text-primary": "hsl(205, 97%, 35%)",
        "color-text-primary-inverse": "hsl(0, 0%, 100%)",
        "color-text-secondary": "hsl(329, 75%, 30%)",
        "color-thumbnail-fill-1": "hsl(205, 97%, 91%)",
        "color-thumbnail-fill-2": "hsl(205, 97%, 81%)",
        "color-thumbnail-fill-3": "hsl(205, 97%, 51%)",
        "color-thumbnail-fill-4": "hsl(205, 97%, 35%)",
        "color-zero-state-base-fill-1": "hsl(216, 0%, 100%)",
        "color-zero-state-base-fill-2": "hsl(216, 13%, 79%)",
        "color-zero-state-base-fill-3": "hsl(216, 13%, 84%)",
        "color-zero-state-modifier-fill-1": "hsl(216, 13%, 96%)",
        "color-zero-state-modifier-fill-2": "hsl(205, 97%, 35%)",
        "color-zero-state-modifier-fill-3": "hsl(205, 97%, 75%)",
        "color-zero-state-modifier-fill-4": "hsl(216, 13%, 92%)",
        "color-zero-state-modifier-fill-5": "hsl(216, 13%, 63%)",
        "duration-100": "100ms",
        "duration-1000": "1s",
        "duration-200": "200ms",
        "duration-250": "250ms",
        "duration-300": "300ms",
        "duration-400": "400ms",
        "duration-450": "450ms",
        "duration-500": "500ms",
        "duration-700": "700ms",
        "ease-in": "cubic-bezier(0, 0.5, 0.2, 1)",
        "ease-in-out": "cubic-bezier(0.5, 0, 0.2, 1)",
        "ease-out": "cubic-bezier(0.5, 0, 0.8, 1)",
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-family-secondary": "'AvenirNext', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        "font-size-base-text": "16px",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": "0.75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-1": "30.8px",
        "font-size-line-height-heading-text-2": "28px",
        "font-size-line-height-heading-text-3": "25.2px",
        "font-size-line-height-heading-text-4": "22.4px",
        "font-size-line-height-heading-text-5": "19.6px",
        "font-size-line-height-heading-text-6": "16.8px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-size-ratio": "1.125",
        "font-size-ratio-major-second": "1.125",
        "font-size-ratio-major-third": "1.25",
        "font-size-ratio-minor-third": "1.2",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "2px",
        "font-space-letter-spacing-m": "1px",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "-1px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "font-space-word": "normal",
        "font-space-word-l": "2px",
        "font-space-word-m": "normal",
        "font-space-word-s": "1px",
        "font-style-expression": "normal",
        "font-style-expression-italic": "italic",
        "font-style-expression-normal": "normal",
        "font-style-expression-oblique": "oblique",
        "font-style-overflow-wrap": "anywhere",
        "font-style-overflow-wrap-anywhere": "anywhere",
        "font-style-overflow-wrap-break-word": "break-word",
        "font-style-overflow-wrap-normal": "normal",
        "font-style-text-transform": "none",
        "font-style-text-transform-capitalize": "capitalize",
        "font-style-text-transform-lowercase": "lowercase",
        "font-style-text-transform-none": "none",
        "font-style-text-transform-uppercase": "uppercase",
        "font-style-weight-300": "300",
        "font-style-weight-400": "400",
        "font-style-weight-500": "500",
        "font-style-weight-600": "600",
        "font-style-weight-700": "700",
        "font-style-word-break": "break-all",
        "font-style-word-break-break-all": "break-all",
        "font-style-word-break-break-word": "break-word",
        "font-style-word-break-keep-all": "keep-all",
        "font-style-word-break-normal": "normal",
        "shadow-depth-l": "0 8px 12px rgba(0, 0, 0, 0.04), 0 16px 24px rgba(0, 0, 0, 0.08)",
        "shadow-depth-m": "0 2px 4px rgba(0, 0, 0, 0.04), 0 8px 16px rgba(0, 0, 0, 0.08)",
        "shadow-depth-s": "0 2px 2px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xl": "0 16px 24px rgba(0, 0, 0, 0.04), 0 32px 48px rgba(0, 0, 0, 0.08)",
        "shadow-depth-xs": "0 1px 2px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.08)",
        "size-action-border-width-focus": "1px",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-border-width-l": "3px",
        "size-border-width-m": "2px",
        "size-border-width-null": "0",
        "size-border-width-s": "1px",
        "size-container-l": "400px",
        "size-container-m": "320px",
        "size-container-null": "0",
        "size-container-s": "240px",
        "size-container-xl": "640px",
        "size-container-xs": "192px",
        "size-container-xxl": "960px",
        "size-container-xxs": "96px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "size-outline-width-l": "3px",
        "size-outline-width-m": "2px",
        "size-outline-width-s": "1px",
        "size-outline-width-xl": "4px",
        "size-zero-state-border-width": "0",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "2.875rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4.125rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.4375rem 0.8125rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem",
        "style-action-border-focus": "dotted"
    }
};

const LowDensityChineseVariantsLocalesTokens = {
    "name": "low-density-chinese-variants-locales",
    "selectors": ["[data-sas-theme='low-density']:lang(zh)", "[data-sas-theme='low-density']:lang(zh-cn)", "[data-sas-theme='low-density']:lang(zh-sg)", "[data-sas-theme='low-density']:lang(zh-hans)", "[data-sas-theme='low-density']:lang(zh-cn-pseudo)", "[data-sas-theme='low-density']:lang(zh-hk)", "[data-sas-theme='low-density']:lang(zh-tw)", "[data-sas-theme='low-density']:lang(zh-hant)"],
    "tokens": {
        "font-size-body-text-l": "1.25rem",
        "font-size-body-text-m": "1.125rem",
        "font-size-body-text-s": "1rem",
        "font-size-body-text-xl": "1.4375rem",
        "font-size-body-text-xs": "0.875rem",
        "font-size-body-text-xxl": "1.625rem",
        "font-size-body-text-xxs": "0.75rem",
        "font-size-body-text-xxxl": "1.8125rem",
        "font-size-body-text-xxxs": "0.6875rem",
        "font-size-body-text-xxxxl": "2rem",
        "font-size-display-text-1": "5.25rem",
        "font-size-display-text-2": "4.625rem",
        "font-size-display-text-3": "3.25rem",
        "font-size-heading-text-1": "1.8125re",
        "font-size-heading-text-2": "1.625rem",
        "font-size-heading-text-3": "1.4375rem",
        "font-size-heading-text-4": "1.25rem",
        "font-size-heading-text-5": "1.125rem",
        "font-size-heading-text-6": "1rem",
        "font-size-heading-text-l": "1.25rem",
        "font-size-heading-text-m": "1.125rem",
        "font-size-heading-text-s": "1rem",
        "font-size-heading-text-xl": "1.4375rem",
        "font-size-heading-text-xxl": "1.625rem",
        "font-size-heading-text-xxxl": "1.8125rem",
        "font-size-heading-text-xxxxl": "2.25rem",
        "font-size-heading-text-xxxxxl": "3.625rem",
        "font-size-heading-text-xxxxxxl": "4.625rem",
        "font-size-line-height-body-text-l": "32px",
        "font-size-line-height-body-text-m": "28.8px",
        "font-size-line-height-body-text-s": "25.6px",
        "font-size-line-height-body-text-xl": "36.8px",
        "font-size-line-height-body-text-xs": "22.4px",
        "font-size-line-height-body-text-xxl": "41.6px",
        "font-size-line-height-body-text-xxs": "19.2px",
        "font-size-line-height-body-text-xxxl": "46.4px",
        "font-size-line-height-body-text-xxxs": "17.6px",
        "font-size-line-height-body-text-xxxxl": "51.2px",
        "font-size-line-height-display-text-1": "134.4px",
        "font-size-line-height-display-text-2": "118.4px",
        "font-size-line-height-display-text-3": "83.2px",
        "font-size-line-height-heading-text-1": "46.4px",
        "font-size-line-height-heading-text-2": "41.6px",
        "font-size-line-height-heading-text-3": "36.8px",
        "font-size-line-height-heading-text-4": "32px",
        "font-size-line-height-heading-text-5": "28.8px",
        "font-size-line-height-heading-text-6": "25.6px",
        "font-size-line-height-heading-text-l": "32px",
        "font-size-line-height-heading-text-m": "28.8px",
        "font-size-line-height-heading-text-s": "25.6px",
        "font-size-line-height-heading-text-xl": "36.8px",
        "font-size-line-height-heading-text-xxl": "41.6px",
        "font-size-line-height-heading-text-xxxl": "46.4px",
        "font-size-line-height-heading-text-xxxxl": "57.6px",
        "font-size-line-height-heading-text-xxxxxl": "118.4px",
        "font-space-line-height": "1.6",
        "font-space-line-height-l": "1.8",
        "font-space-line-height-m": "1.7",
        "font-space-line-height-s": "1.6",
        "font-space-line-height-xl": "1.9",
        "font-space-line-height-xxl": "2.0",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "36px",
        "size-border-radius-m": "24px",
        "size-border-radius-s": "12px",
        "size-border-radius-xs": "6px",
        "size-border-radius-xxs": "3px",
        "size-icon-l": "1.25rem",
        "size-icon-m": "1.125rem",
        "size-icon-s": "1rem",
        "size-icon-xl": "1.4375rem",
        "size-icon-xs": "1rem",
        "size-icon-xxl": "1.625rem",
        "size-icon-xxs": "1rem",
        "size-icon-xxxl": "1.8125rem",
        "size-icon-xxxs": "1rem",
        "size-icon-xxxxl": "2rem",
        "space-base-l": "1.75rem",
        "space-base-m": "1.25rem",
        "space-base-null": "0",
        "space-base-s": "0.6875rem",
        "space-base-size": "1rem",
        "space-base-xl": "2.5625rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "3.1875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.625rem",
        "space-base-xxxxl": "4.5625rem",
        "space-base-xxxxxl": "5.125rem",
        "space-block-l": "1.75rem",
        "space-block-m": "1.25rem",
        "space-block-s": "0.625rem",
        "space-block-xl": "2.5625rem",
        "space-block-xs": "0.3125rem",
        "space-block-xxl": "3.1875rem",
        "space-block-xxs": "0.1875rem",
        "space-block-xxxl": "3.625rem",
        "space-block-xxxxl": "4.5625rem",
        "space-block-xxxxxl": "5.125rem",
        "space-inline-l": "1.75rem",
        "space-inline-m": "1.25rem",
        "space-inline-s": "0.625rem",
        "space-inline-xl": "2.5625rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "3.1875rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3.625rem",
        "space-inline-xxxxl": "4.5625rem",
        "space-inline-xxxxxl": "5.125rem",
        "space-squish-l": "1rem 1.75rem",
        "space-squish-m": "0.625rem 1.25rem",
        "space-squish-s": "0.3125rem 0.625rem",
        "space-squish-xl": "1.25rem 2.5625rem",
        "space-squish-xs": "0.1875rem 0.3125rem",
        "space-squish-xxl": "1.5625rem 3.1875rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.75rem 1rem",
        "space-stretch-m": "1.25rem 0.625rem",
        "space-stretch-s": "0.625rem 0.3125rem",
        "space-stretch-xs": ".3125rem 0.1875rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const LowDensityEuroSlavicLocalesTokens = {
    "name": "low-density-euro-slavic-locales",
    "selectors": ["[data-sas-theme='low-density']:lang(en)"],
    "tokens": {
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125re",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-1": "1.625rem",
        "font-size-heading-text-2": "1.4375rem",
        "font-size-heading-text-3": "1.25rem",
        "font-size-heading-text-4": "1.125rem",
        "font-size-heading-text-5": "1rem",
        "font-size-heading-text-6": "0.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "27px",
        "font-size-line-height-body-text-m": "24px",
        "font-size-line-height-body-text-s": "21px",
        "font-size-line-height-body-text-xl": "30px",
        "font-size-line-height-body-text-xs": "19.5px",
        "font-size-line-height-body-text-xxl": "34.5px",
        "font-size-line-height-body-text-xxs": "16.5px",
        "font-size-line-height-body-text-xxxl": "39px",
        "font-size-line-height-body-text-xxxs": "15px",
        "font-size-line-height-body-text-xxxxl": "43.5px",
        "font-size-line-height-display-text-1": "124.5px",
        "font-size-line-height-display-text-2": "99px",
        "font-size-line-height-display-text-3": "69px",
        "font-size-line-height-heading-text-1": "39px",
        "font-size-line-height-heading-text-2": "34.5px",
        "font-size-line-height-heading-text-3": "30px",
        "font-size-line-height-heading-text-4": "27px",
        "font-size-line-height-heading-text-5": "24px",
        "font-size-line-height-heading-text-6": "21px",
        "font-size-line-height-heading-text-l": "27px",
        "font-size-line-height-heading-text-m": "24px",
        "font-size-line-height-heading-text-s": "21px",
        "font-size-line-height-heading-text-xl": "30px",
        "font-size-line-height-heading-text-xxl": "34.4px",
        "font-size-line-height-heading-text-xxxl": "39px",
        "font-size-line-height-heading-text-xxxxl": "48px",
        "font-size-line-height-heading-text-xxxxxl": "99px",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "36px",
        "size-border-radius-m": "24px",
        "size-border-radius-s": "12px",
        "size-border-radius-xs": "6px",
        "size-border-radius-xxs": "3px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.8125re",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.8125re",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.8125re",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem",
        "space-block-l": "1.625rem",
        "space-block-m": "1.125rem",
        "space-block-s": "0.5625rem",
        "space-block-xl": "2.25rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.875rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "3.25rem",
        "space-block-xxxxl": "4.125rem",
        "space-block-xxxxxl": "4.625rem",
        "space-inline-l": "1.625rem",
        "space-inline-m": "1.125rem",
        "space-inline-s": "0.5625rem",
        "space-inline-xl": "2.25rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.875rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3.25rem",
        "space-inline-xxxxl": "4.125rem",
        "space-inline-xxxxxl": "4.625rem",
        "space-squish-l": "0.875rem 1.625rem",
        "space-squish-m": "0.5625rem 1.125rem",
        "space-squish-s": "0.25rem 0.5625rem",
        "space-squish-xl": "1.125rem 2.25rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.4375rem 2.875rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.625rem 0.75rem",
        "space-stretch-m": "1.125rem 0.5625rem",
        "space-stretch-s": "0.5625rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const LowDensityMenaAsianLocalesTokens = {
    "name": "low-density-mena-asian-locales",
    "selectors": ["[data-sas-theme='low-density']:lang(ar)", "[data-sas-theme='low-density']:lang(ar-xx)", "[data-sas-theme='low-density']:lang(he)", "[data-sas-theme='low-density']:lang(jp)", "[data-sas-theme='low-density']:lang(ko)", "[data-sas-theme='low-density']:lang(th)", "[data-sas-theme='low-density']:lang(vi)", "[data-sas-theme='low-density']:lang(vi-VN)"],
    "tokens": {
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125r",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-1": "1.625rem",
        "font-size-heading-text-2": "1.4375rem",
        "font-size-heading-text-3": "1.25rem",
        "font-size-heading-text-4": "1.125rem",
        "font-size-heading-text-5": "1rem",
        "font-size-heading-text-6": "0.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "28.8px",
        "font-size-line-height-body-text-m": "25.6px",
        "font-size-line-height-body-text-s": "22.4px",
        "font-size-line-height-body-text-xl": "32px",
        "font-size-line-height-body-text-xs": "20.8px",
        "font-size-line-height-body-text-xxl": "36.8px",
        "font-size-line-height-body-text-xxs": "17.8px",
        "font-size-line-height-body-text-xxxl": "41.6px",
        "font-size-line-height-body-text-xxxs": "16px",
        "font-size-line-height-body-text-xxxxl": "46.4px",
        "font-size-line-height-display-text-1": "132.8px",
        "font-size-line-height-display-text-2": "105.6px",
        "font-size-line-height-display-text-3": "73.6px",
        "font-size-line-height-heading-text-1": "41.6px",
        "font-size-line-height-heading-text-2": "36.8px",
        "font-size-line-height-heading-text-3": "32px",
        "font-size-line-height-heading-text-4": "28.8px",
        "font-size-line-height-heading-text-5": "25.6px",
        "font-size-line-height-heading-text-6": "22.4px",
        "font-size-line-height-heading-text-l": "28.8px",
        "font-size-line-height-heading-text-m": "25.6px",
        "font-size-line-height-heading-text-s": "22.4px",
        "font-size-line-height-heading-text-xl": "32px",
        "font-size-line-height-heading-text-xxl": "36.8px",
        "font-size-line-height-heading-text-xxxl": "41.6px",
        "font-size-line-height-heading-text-xxxxl": "51.2px",
        "font-size-line-height-heading-text-xxxxxl": "105.6px",
        "font-space-line-height": "1.6",
        "font-space-line-height-l": "1.8",
        "font-space-line-height-m": "1.7",
        "font-space-line-height-s": "1.6",
        "font-space-line-height-xl": "1.9",
        "font-space-line-height-xxl": "2.0",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "36px",
        "size-border-radius-m": "24px",
        "size-border-radius-s": "12px",
        "size-border-radius-xs": "6px",
        "size-border-radius-xxs": "3px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125r",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1rem",
        "space-base-xl": "2.5rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem",
        "space-block-l": "1.625rem",
        "space-block-m": "1.125rem",
        "space-block-s": "0.5625rem",
        "space-block-xl": "2.25rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.875rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "3.25rem",
        "space-block-xxxxl": "4.125rem",
        "space-block-xxxxxl": "4.625rem",
        "space-inline-l": "1.625rem",
        "space-inline-m": "1.125rem",
        "space-inline-s": "0.5625rem",
        "space-inline-xl": "2.25rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.875rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4.625rem",
        "space-squish-l": "0.875rem 1.625rem",
        "space-squish-m": "0.5625rem 1.125rem",
        "space-squish-s": "0.25rem 0.5625rem",
        "space-squish-xl": "1.125rem 2.25rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.4375rem 2.875rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.625rem 0.875rem",
        "space-stretch-m": "1.125rem 0.5625rem",
        "space-stretch-s": "0.5625rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const LowDensityTokens = {
    "name": "low-density",
    "selectors": ["[data-sas-theme='low-density']"],
    "tokens": {
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125re",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-1": "1.625rem",
        "font-size-heading-text-2": "1.4375rem",
        "font-size-heading-text-3": "1.25rem",
        "font-size-heading-text-4": "1.125rem",
        "font-size-heading-text-5": "1rem",
        "font-size-heading-text-6": "0.875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "27px",
        "font-size-line-height-body-text-m": "24px",
        "font-size-line-height-body-text-s": "21px",
        "font-size-line-height-body-text-xl": "30px",
        "font-size-line-height-body-text-xs": "19.5px",
        "font-size-line-height-body-text-xxl": "34.5px",
        "font-size-line-height-body-text-xxs": "16.5px",
        "font-size-line-height-body-text-xxxl": "39px",
        "font-size-line-height-body-text-xxxs": "15px",
        "font-size-line-height-body-text-xxxxl": "43.5px",
        "font-size-line-height-display-text-1": "124.5px",
        "font-size-line-height-display-text-2": "99px",
        "font-size-line-height-display-text-3": "69px",
        "font-size-line-height-heading-text-1": "39px",
        "font-size-line-height-heading-text-2": "34.5px",
        "font-size-line-height-heading-text-3": "30px",
        "font-size-line-height-heading-text-4": "27px",
        "font-size-line-height-heading-text-5": "24px",
        "font-size-line-height-heading-text-6": "21px",
        "font-size-line-height-heading-text-l": "27px",
        "font-size-line-height-heading-text-m": "24px",
        "font-size-line-height-heading-text-s": "21px",
        "font-size-line-height-heading-text-xl": "30px",
        "font-size-line-height-heading-text-xxl": "34.4px",
        "font-size-line-height-heading-text-xxxl": "39px",
        "font-size-line-height-heading-text-xxxxl": "48px",
        "font-size-line-height-heading-text-xxxxxl": "99px",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "36px",
        "size-border-radius-m": "24px",
        "size-border-radius-s": "12px",
        "size-border-radius-xs": "6px",
        "size-border-radius-xxs": "3px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.8125re",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.8125re",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.8125re",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem",
        "space-block-l": "1.625rem",
        "space-block-m": "1.125rem",
        "space-block-s": "0.5625rem",
        "space-block-xl": "2.25rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.875rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "3.25rem",
        "space-block-xxxxl": "4.125rem",
        "space-block-xxxxxl": "4.625rem",
        "space-inline-l": "1.625rem",
        "space-inline-m": "1.125rem",
        "space-inline-s": "0.5625rem",
        "space-inline-xl": "2.25rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.875rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3.25rem",
        "space-inline-xxxxl": "4.125rem",
        "space-inline-xxxxxl": "4.625rem",
        "space-squish-l": "0.875rem 1.625rem",
        "space-squish-m": "0.5625rem 1.125rem",
        "space-squish-s": "0.25rem 0.5625rem",
        "space-squish-xl": "1.125rem 2.25rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.4375rem 2.875rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.625rem 0.75rem",
        "space-stretch-m": "1.125rem 0.5625rem",
        "space-stretch-s": "0.5625rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const MediumDensityChineseVariantsLocalesTokens = {
    "name": "medium-density-chinese-variants-locales",
    "selectors": ["[data-sas-theme='low-density']:lang(zh)", "[data-sas-theme='low-density']:lang(zh-cn)", "[data-sas-theme='low-density']:lang(zh-sg)", "[data-sas-theme='low-density']:lang(zh-hans)", "[data-sas-theme='low-density']:lang(zh-cn-pseudo)", "[data-sas-theme='low-density']:lang(zh-hk)", "[data-sas-theme='low-density']:lang(zh-tw)", "[data-sas-theme='low-density']:lang(zh-hant)"],
    "tokens": {
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-1": "1.625rem",
        "font-size-heading-text-2": "1.4375rem",
        "font-size-heading-text-3": "1.25rem",
        "font-size-heading-text-4": "1.125rem",
        "font-size-heading-text-5": "1rem",
        "font-size-heading-text-6": ".875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "27px",
        "font-size-line-height-body-text-m": "24px",
        "font-size-line-height-body-text-s": "21px",
        "font-size-line-height-body-text-xl": "30px",
        "font-size-line-height-body-text-xs": "19.5px",
        "font-size-line-height-body-text-xxl": "34.5px",
        "font-size-line-height-body-text-xxs": "16.5px",
        "font-size-line-height-body-text-xxxl": "39px",
        "font-size-line-height-body-text-xxxs": "15px",
        "font-size-line-height-body-text-xxxxl": "48px",
        "font-size-line-height-display-text-1": "124.5px",
        "font-size-line-height-display-text-2": "99px",
        "font-size-line-height-display-text-3": "69px",
        "font-size-line-height-heading-text-1": "34.5px",
        "font-size-line-height-heading-text-2": "30px",
        "font-size-line-height-heading-text-3": "34.5px",
        "font-size-line-height-heading-text-4": "30px",
        "font-size-line-height-heading-text-5": "24px",
        "font-size-line-height-heading-text-6": "21px",
        "font-size-line-height-heading-text-l": "27px",
        "font-size-line-height-heading-text-m": "24px",
        "font-size-line-height-heading-text-s": "21px",
        "font-size-line-height-heading-text-xl": "30px",
        "font-size-line-height-heading-text-xxl": "34.5px",
        "font-size-line-height-heading-text-xxxl": "39px",
        "font-size-line-height-heading-text-xxxxl": "48px",
        "font-size-line-height-heading-text-xxxxxl": "99px",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1.125rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem",
        "space-block-l": "1.625rem",
        "space-block-m": "0.875rem",
        "space-block-s": "0.5625rem",
        "space-block-xl": "2.25rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.875remm",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "3.25rem",
        "space-block-xxxxl": "4.125rem",
        "space-block-xxxxxl": "4.625rem",
        "space-inline-l": "1.625rem",
        "space-inline-m": "1.25rem",
        "space-inline-s": "0.5625rem",
        "space-inline-xl": "2.25rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.875rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3.25rem",
        "space-inline-xxxxl": "4.125rem",
        "space-inline-xxxxxl": "4.625rem",
        "space-squish-l": "0.875rem 1.625rem",
        "space-squish-m": "0.5625rem 1.125rem",
        "space-squish-s": "0.25rem 0.5625rem",
        "space-squish-xl": "1.125rem 2.25rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.4375rem 2.875rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.625rem 0.875rem",
        "space-stretch-m": "1.125rem 0.5625rem",
        "space-stretch-s": "0.5625rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const MediumDensityEuroSlavicLocalesTokens = {
    "name": "medium-density-euro-slavic-locales",
    "selectors": ["[data-sas-theme='medium-density']:lang(en)"],
    "tokens": {
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": "0.75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-1": "30.8px",
        "font-size-line-height-heading-text-2": "28px",
        "font-size-line-height-heading-text-3": "25.2px",
        "font-size-line-height-heading-text-4": "22.4px",
        "font-size-line-height-heading-text-5": "19.6px",
        "font-size-line-height-heading-text-6": "16.8px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "2.875rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4.125rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.4375rem 0.8125rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const MediumDensityLocalesOtherTokens = {
    "name": "medium-density-locales-other",
    "selectors": ["[data-sas-theme='medium-density']:lang(ar)", "[data-sas-theme='medium-density']:lang(ar-xx)", "[data-sas-theme='medium-density']:lang(he)", "[data-sas-theme='medium-density']:lang(jp)", "[data-sas-theme='medium-density']:lang(ko)", "[data-sas-theme='medium-density']:lang(th)", "[data-sas-theme='medium-density']:lang(vi)", "[data-sas-theme='medium-density']:lang(vi-VN)"],
    "tokens": {
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": ".75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-1": "33px",
        "font-size-line-height-heading-text-2": "30px",
        "font-size-line-height-heading-text-3": "27px",
        "font-size-line-height-heading-text-4": "24px",
        "font-size-line-height-heading-text-5": "21px",
        "font-size-line-height-heading-text-6": "18px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.5rem 0.75rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const MediumDensityTokens = {
    "name": "medium-density",
    "selectors": ["[data-sas-theme='medium-density']"],
    "tokens": {
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": "0.75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "22.4px",
        "font-size-line-height-body-text-m": "19.6px",
        "font-size-line-height-body-text-s": "16.8px",
        "font-size-line-height-body-text-xl": "25.2px",
        "font-size-line-height-body-text-xs": "15.4px",
        "font-size-line-height-body-text-xxl": "28px",
        "font-size-line-height-body-text-xxs": "14px",
        "font-size-line-height-body-text-xxxl": "30.8px",
        "font-size-line-height-body-text-xxxs": "12.6px",
        "font-size-line-height-body-text-xxxxl": "35px",
        "font-size-line-height-display-text-1": "102.2px",
        "font-size-line-height-display-text-2": "81px",
        "font-size-line-height-display-text-3": "56px",
        "font-size-line-height-heading-text-1": "30.8px",
        "font-size-line-height-heading-text-2": "28px",
        "font-size-line-height-heading-text-3": "25.2px",
        "font-size-line-height-heading-text-4": "22.4px",
        "font-size-line-height-heading-text-5": "19.6px",
        "font-size-line-height-heading-text-6": "16.8px",
        "font-size-line-height-heading-text-l": "22.4px",
        "font-size-line-height-heading-text-m": "19.6px",
        "font-size-line-height-heading-text-s": "16.8px",
        "font-size-line-height-heading-text-xl": "25.2px",
        "font-size-line-height-heading-text-xxl": "28px",
        "font-size-line-height-heading-text-xxxl": "30.8px",
        "font-size-line-height-heading-text-xxxxl": "39.2px",
        "font-size-line-height-heading-text-xxxxxl": "81px",
        "font-space-line-height": "1.4",
        "font-space-line-height-l": "1.6",
        "font-space-line-height-m": "1.5",
        "font-space-line-height-s": "1.4",
        "font-space-line-height-xl": "1.7",
        "font-space-line-height-xxl": "1.8",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "2.875rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4.125rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.4375rem 0.8125rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const TaiwaneseTokens = {
    "name": "taiwanese",
    "selectors": [":lang(zh-tw)", ":lang(zh-hant)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', '微軟正黑體', 'Microsoft JhengHei', '黑體-繁', 'Heiti TC', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'AvenirNext', '微軟正黑體', 'Microsoft JhengHei', '黑體-繁', 'Heiti TC', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1.125rem",
        "font-size-body-text-m": "1rem",
        "font-size-body-text-s": "0.875rem",
        "font-size-body-text-xl": "1.25rem",
        "font-size-body-text-xs": "0.8125rem",
        "font-size-body-text-xxl": "1.4375rem",
        "font-size-body-text-xxs": "0.6875rem",
        "font-size-body-text-xxxl": "1.625rem",
        "font-size-body-text-xxxs": "0.625rem",
        "font-size-body-text-xxxxl": "1.8125rem",
        "font-size-display-text-1": "5.1875rem",
        "font-size-display-text-2": "4.125rem",
        "font-size-display-text-3": "2.875rem",
        "font-size-heading-text-1": "1.625rem",
        "font-size-heading-text-2": "1.4375rem",
        "font-size-heading-text-3": "1.25rem",
        "font-size-heading-text-4": "1.125rem",
        "font-size-heading-text-5": "1rem",
        "font-size-heading-text-6": ".875rem",
        "font-size-heading-text-l": "1.125rem",
        "font-size-heading-text-m": "1rem",
        "font-size-heading-text-s": "0.875rem",
        "font-size-heading-text-xl": "1.25rem",
        "font-size-heading-text-xxl": "1.4375rem",
        "font-size-heading-text-xxxl": "1.625rem",
        "font-size-heading-text-xxxxl": "2rem",
        "font-size-heading-text-xxxxxl": "3.25rem",
        "font-size-heading-text-xxxxxxl": "4.125rem",
        "font-size-line-height-body-text-l": "27px",
        "font-size-line-height-body-text-m": "24px",
        "font-size-line-height-body-text-s": "21px",
        "font-size-line-height-body-text-xl": "30px",
        "font-size-line-height-body-text-xs": "19.5px",
        "font-size-line-height-body-text-xxl": "34.5px",
        "font-size-line-height-body-text-xxs": "16.5px",
        "font-size-line-height-body-text-xxxl": "39px",
        "font-size-line-height-body-text-xxxs": "15px",
        "font-size-line-height-body-text-xxxxl": "48px",
        "font-size-line-height-display-text-1": "124.5px",
        "font-size-line-height-display-text-2": "99px",
        "font-size-line-height-display-text-3": "69px",
        "font-size-line-height-heading-text-1": "34.5px",
        "font-size-line-height-heading-text-2": "30px",
        "font-size-line-height-heading-text-3": "34.5px",
        "font-size-line-height-heading-text-4": "30px",
        "font-size-line-height-heading-text-5": "24px",
        "font-size-line-height-heading-text-6": "21px",
        "font-size-line-height-heading-text-l": "27px",
        "font-size-line-height-heading-text-m": "24px",
        "font-size-line-height-heading-text-s": "21px",
        "font-size-line-height-heading-text-xl": "30px",
        "font-size-line-height-heading-text-xxl": "34.5px",
        "font-size-line-height-heading-text-xxxl": "39px",
        "font-size-line-height-heading-text-xxxxl": "48px",
        "font-size-line-height-heading-text-xxxxxl": "99px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-text-transform-uppercase": "initial",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1.125rem",
        "size-icon-m": "1rem",
        "size-icon-s": "0.875rem",
        "size-icon-xl": "1.25rem",
        "size-icon-xs": "0.875rem",
        "size-icon-xxl": "1.4375rem",
        "size-icon-xxs": "0.875rem",
        "size-icon-xxxl": "1.625rem",
        "size-icon-xxxs": "0.875rem",
        "size-icon-xxxxl": "1.8125rem",
        "space-base-l": "1.625rem",
        "space-base-m": "1.125rem",
        "space-base-null": "0",
        "space-base-s": "0.5625rem",
        "space-base-size": "1.125rem",
        "space-base-xl": "2.25rem",
        "space-base-xs": "0.3125rem",
        "space-base-xxl": "2.875rem",
        "space-base-xxs": "0.1875rem",
        "space-base-xxxl": "3.25rem",
        "space-base-xxxxl": "4.125rem",
        "space-base-xxxxxl": "4.625rem",
        "space-block-l": "1.625rem",
        "space-block-m": "0.875rem",
        "space-block-s": "0.5625rem",
        "space-block-xl": "2.25rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.875remm",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "3.25rem",
        "space-block-xxxxl": "4.125rem",
        "space-block-xxxxxl": "4.625rem",
        "space-inline-l": "1.625rem",
        "space-inline-m": "1.25rem",
        "space-inline-s": "0.5625rem",
        "space-inline-xl": "2.25rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.875rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3.25rem",
        "space-inline-xxxxl": "4.125rem",
        "space-inline-xxxxxl": "4.625rem",
        "space-squish-l": "0.875rem 1.625rem",
        "space-squish-m": "0.5625rem 1.125rem",
        "space-squish-s": "0.25rem 0.5625rem",
        "space-squish-xl": "1.125rem 2.25rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.4375rem 2.875rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.625rem 0.875rem",
        "space-stretch-m": "1.125rem 0.5625rem",
        "space-stretch-s": "0.5625rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const ThaiTokens = {
    "name": "thai",
    "selectors": [":lang(th)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', 'Thonburi', 'Leelawadee UI', 'TH Sarabun New', 'Cordia New', Roboto, Noto, 'Noto Sans Thai', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'AvenirNext', 'Thonburi', 'Leelawadee UI', 'TH Sarabun New', 'Cordia New', Roboto, Noto, 'Noto Sans Thai', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": ".75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-1": "33px",
        "font-size-line-height-heading-text-2": "30px",
        "font-size-line-height-heading-text-3": "27px",
        "font-size-line-height-heading-text-4": "24px",
        "font-size-line-height-heading-text-5": "21px",
        "font-size-line-height-heading-text-6": "18px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-letter-spacing": "normal",
        "font-space-letter-spacing-l": "normal",
        "font-space-letter-spacing-m": "normal",
        "font-space-letter-spacing-s": "normal",
        "font-space-letter-spacing-xs": "normal",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "font-style-expression-italic": "normal",
        "font-style-weight-300": "400",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.5rem 0.75rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

const VietnameseTokens = {
    "name": "vietnamese",
    "selectors": [":lang(vi)", ":lang(vi-VN)"],
    "tokens": {
        "font-family-monospace": "Consolas, Menlo, 'Lucida Console', Courier, Monaco, monospace",
        "font-family-primary": "'AvenirNext', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-family-secondary": "'AvenirNext', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        "font-size-body-text-l": "1rem",
        "font-size-body-text-m": "0.875rem",
        "font-size-body-text-s": "0.75rem",
        "font-size-body-text-xl": "1.125rem",
        "font-size-body-text-xs": "0.6875rem",
        "font-size-body-text-xxl": "1.25rem",
        "font-size-body-text-xxs": "0.625rem",
        "font-size-body-text-xxxl": "1.375rem",
        "font-size-body-text-xxxs": "0.5625rem",
        "font-size-body-text-xxxxl": "1.5625rem",
        "font-size-display-text-1": "4.5625rem",
        "font-size-display-text-2": "3.625rem",
        "font-size-display-text-3": "2.5rem",
        "font-size-heading-text-1": "1.375rem",
        "font-size-heading-text-2": "1.25rem",
        "font-size-heading-text-3": "1.125rem",
        "font-size-heading-text-4": "1rem",
        "font-size-heading-text-5": "0.875rem",
        "font-size-heading-text-6": ".75rem",
        "font-size-heading-text-l": "1rem",
        "font-size-heading-text-m": "0.875rem",
        "font-size-heading-text-s": "0.75rem",
        "font-size-heading-text-xl": "1.125rem",
        "font-size-heading-text-xxl": "1.25rem",
        "font-size-heading-text-xxxl": "1.375rem",
        "font-size-heading-text-xxxxl": "1.75rem",
        "font-size-heading-text-xxxxxl": "2.8125rem",
        "font-size-heading-text-xxxxxxl": "3.625rem",
        "font-size-line-height-body-text-l": "24px",
        "font-size-line-height-body-text-m": "21px",
        "font-size-line-height-body-text-s": "18px",
        "font-size-line-height-body-text-xl": "27px",
        "font-size-line-height-body-text-xs": "16.5px",
        "font-size-line-height-body-text-xxl": "30px",
        "font-size-line-height-body-text-xxs": "15px",
        "font-size-line-height-body-text-xxxl": "33px",
        "font-size-line-height-body-text-xxxs": "13.5px",
        "font-size-line-height-body-text-xxxxl": "37.5px",
        "font-size-line-height-display-text-1": "109.5px",
        "font-size-line-height-display-text-2": "87px",
        "font-size-line-height-display-text-3": "60px",
        "font-size-line-height-heading-text-1": "33px",
        "font-size-line-height-heading-text-2": "30px",
        "font-size-line-height-heading-text-3": "27px",
        "font-size-line-height-heading-text-4": "24px",
        "font-size-line-height-heading-text-5": "21px",
        "font-size-line-height-heading-text-6": "18px",
        "font-size-line-height-heading-text-l": "24px",
        "font-size-line-height-heading-text-m": "21px",
        "font-size-line-height-heading-text-s": "18px",
        "font-size-line-height-heading-text-xl": "27px",
        "font-size-line-height-heading-text-xxl": "30px",
        "font-size-line-height-heading-text-xxxl": "33px",
        "font-size-line-height-heading-text-xxxxl": "42px",
        "font-size-line-height-heading-text-xxxxxl": "87px",
        "font-space-line-height": "1.5",
        "font-space-line-height-l": "1.7",
        "font-space-line-height-m": "1.6",
        "font-space-line-height-s": "1.5",
        "font-space-line-height-xl": "1.8",
        "font-space-line-height-xxl": "1.9",
        "size-border-radius-full": "50%",
        "size-border-radius-l": "24px",
        "size-border-radius-m": "16px",
        "size-border-radius-s": "8px",
        "size-border-radius-xs": "4px",
        "size-border-radius-xxs": "2px",
        "size-icon-l": "1rem",
        "size-icon-m": "0.875rem",
        "size-icon-s": "0.75rem",
        "size-icon-xl": "1.125rem",
        "size-icon-xs": "0.75rem",
        "size-icon-xxl": "1.25rem",
        "size-icon-xxs": "0.75rem",
        "size-icon-xxxl": "1.375rem",
        "size-icon-xxxs": "0.75rem",
        "size-icon-xxxxl": "1.5625rem",
        "space-base-l": "1.4375rem",
        "space-base-m": "1rem",
        "space-base-null": "0",
        "space-base-s": "0.5rem",
        "space-base-size": "1rem",
        "space-base-xl": "2rem",
        "space-base-xs": "0.25rem",
        "space-base-xxl": "2.5625rem",
        "space-base-xxs": "0.125rem",
        "space-base-xxxl": "2.875rem",
        "space-base-xxxxl": "3.625rem",
        "space-base-xxxxxl": "4.125rem",
        "space-block-l": "1.4375rem",
        "space-block-m": "1rem",
        "space-block-s": "0.5rem",
        "space-block-xl": "2rem",
        "space-block-xs": "0.25rem",
        "space-block-xxl": "2.5625rem",
        "space-block-xxs": "0.125rem",
        "space-block-xxxl": "2.875rem",
        "space-block-xxxxl": "3.625rem",
        "space-block-xxxxxl": "4.125rem",
        "space-inline-l": "1.4375rem",
        "space-inline-m": "1rem",
        "space-inline-s": "0.5rem",
        "space-inline-xl": "2rem",
        "space-inline-xs": "0.25rem",
        "space-inline-xxl": "2.5625rem",
        "space-inline-xxs": "0.125rem",
        "space-inline-xxxl": "3rem",
        "space-inline-xxxxl": "3.625rem",
        "space-inline-xxxxxl": "4rem",
        "space-squish-l": "0.8125rem 1.4375rem",
        "space-squish-m": "0.5rem 1rem",
        "space-squish-s": "0.25rem 0.5rem",
        "space-squish-xl": "1rem 2rem",
        "space-squish-xs": "0.125rem 0.25rem",
        "space-squish-xxl": "1.25rem 2.5625rem",
        "space-squish-xxs": "0.0625rem 0.125rem",
        "space-stretch-l": "1.5rem 0.75rem",
        "space-stretch-m": "1rem 0.5rem",
        "space-stretch-s": "0.5rem 0.25rem",
        "space-stretch-xs": "0.25rem 0.125rem",
        "space-stretch-xxs": "0.125rem 0.0625rem"
    }
};

export { ArabicPseudoTokens, ArabicTokens, ChineseChinaTokens, ChineseHongKongTokens, ChinesePseudoTokens, DarkTokens, EnglishTokens, HebrewTokens, HighContrastTokens, HighDensityChineseVariantsLocalesTokens, HighDensityEuroSlavicLocalesTokens, HighDensityMenaAsianLocalesTokens, HighDensityTokens, JapaneseTokens, KoreanTokens, LightTokens, LowDensityChineseVariantsLocalesTokens, LowDensityEuroSlavicLocalesTokens, LowDensityMenaAsianLocalesTokens, LowDensityTokens, MediumDensityChineseVariantsLocalesTokens, MediumDensityEuroSlavicLocalesTokens, MediumDensityLocalesOtherTokens, MediumDensityTokens, TaiwaneseTokens, ThaiTokens, VietnameseTokens };
//# sourceMappingURL=index.js.map
